var COLLECTION_DEBOUNCE = {
  searchInput: 360,
  searchBlur: 180,
  filterApply: 320,
  clearAll: 180,
  dialogSelect: 320
};
var STATUS_CLEAR_MS = 2200;

async function init(context) {
  if (typeof document === "undefined" || typeof document.querySelectorAll !== "function") return;
  var roots = document.querySelectorAll("[data-ua-collection-order='true']");
  for (var i = 0; i < roots.length; i++) {
    await initCollectionOrder(roots[i], context || {});
  }
}
module.exports.init = init;

async function initCollectionOrder(root, context) {
  if (!(root) || root.getAttribute("data-collection-bound") === "true") return;
  root.setAttribute("data-collection-bound", "true");

  var dashboardApi = (context || {}).dashboardApi || window.DashboardAPI || ((((window.UATools || {}).dashboard || {}).api) || null);
  var grid = root.querySelector("[data-collection-grid='true']");
  var sentinel = root.querySelector("[data-collection-sentinel='true']");
  var emptyNode = root.querySelector("[data-collection-empty='true']");
  var statusNode = root.querySelector("[data-collection-status='true']");
  var searchInput = root.querySelector("[data-collection-search='true']");
  var filterControls = root.querySelectorAll("input[type='hidden'][data-dashboard-filter]");
  var filterDialogBtns = root.querySelectorAll("button[data-dashboard-filter-dialog='true']");
  var clearFiltersBtn = root.querySelector("[data-collection-clear-filters-row='true']");
  var activeFiltersRow = root.querySelector("[data-collection-active-filters-row='true']");
  var activeChipsHost = root.querySelector("[data-collection-active-filter-chips='true']");
  var quickTogglesHost = root.querySelector("[data-collection-quick-toggles='true']");
  var quickToggleEls = root.querySelectorAll("[data-ua-button-toggle='true'][data-toggle-name^='quick-toggle-']");
  var editToggleBtn = root.querySelector("[data-collection-edit-toggle='true']");
  var toggleInput = root.querySelector("[data-collection-locked-toggle='true'] input[type='checkbox']");
  var scriptNode = root.querySelector("script[data-collection-items-json='true']");

  var state = {
    root: root,
    grid: grid,
    sentinel: sentinel,
    emptyNode: emptyNode,
    statusNode: statusNode,
    activeFiltersRow: activeFiltersRow,
    activeChipsHost: activeChipsHost,
    quickTogglesHost: quickTogglesHost,
    dashboardApi: dashboardApi,
    name: (root.getAttribute("data-collection-name") || "").toString(),
    title: (root.getAttribute("data-collection-title") || "").toString(),
    pageNamespace: (root.getAttribute("data-collection-page-namespace") || "").toString(),
    apiUrl: (root.getAttribute("data-collection-api-url") || "").toString(),
    apiFilters: parseObjectAttr(root.getAttribute("data-collection-api-filters")),
    searchable: root.getAttribute("data-collection-searchable") === "true",
    editable: root.getAttribute("data-collection-editable") === "true",
    pinVisibility: normalizePinVisibility(root.getAttribute("data-collection-pin-visibility") || "always"),
    showLockedToggle: root.getAttribute("data-collection-show-locked-toggle") === "true",
    showLocked: root.getAttribute("data-collection-show-locked") !== "false",
    showRemoveButton: root.getAttribute("data-collection-show-remove-button") !== "false",
    emptyMessage: (root.getAttribute("data-collection-empty-message") || "No items found.").toString(),
    saveMode: (root.getAttribute("data-collection-save-mode") || "none").toString().trim().toLowerCase(),
    saveId: (root.getAttribute("data-collection-save-id") || "").toString().trim(),
    saveDebounceMs: Math.max(120, Number(root.getAttribute("data-collection-save-debounce-ms")) || 420),
    apiPageSize: Math.max(1, Number(root.getAttribute("data-collection-api-page-size")) || 30),
    revealSequence: parseRevealSequence(root.getAttribute("data-collection-page-size-sequence") || "25,25,30"),
    filters: {},
    editMode: false,
    cache: {},
    pendingFilterTimer: null,
    pendingSaveTimer: null,
    clearStatusTimer: null,
    observer: null,
    drag: null,
    focusKey: "",
    items: parseDirectItems(scriptNode),
    directItems: parseDirectItems(scriptNode)
  };

  state.items = normalizeItems(state.items);
  state.directItems = normalizeItems(state.directItems);
  root.__uaCollectionOrderState = state;

  if (searchInput && state.searchable) {
    state.filters.search = normalizeFilterValue(searchInput.value || "");
  }

  filterControls.forEach(function(ctrl) {
    var filterName = (ctrl.getAttribute("data-dashboard-filter") || "").trim();
    if (!filterName) return;
    state.filters[filterName] = normalizeFilterValue(ctrl.value || "");
  });

  quickToggleEls.forEach(function(toggleEl) {
    var filterName = quickToggleFilterName(toggleEl);
    if (!filterName) return;
    bindButtonToggle(toggleEl, {
      onChange: function(nextValue) {
        setCollectionFilterValue(state, filterName, nextValue, COLLECTION_DEBOUNCE.filterApply);
      },
      onSettings: async function() {
        await openButtonToggleDialog(toggleEl, function(nextValue) {
          setCollectionFilterValue(state, filterName, nextValue, COLLECTION_DEBOUNCE.filterApply);
        });
      }
    });
    setButtonToggleValue(toggleEl, state.filters[filterName] || "");
  });

  syncCollectionFilterButtonLabels(root, state.filters);
  renderCollectionActiveFilterRow(state);

  if (toggleInput && state.showLockedToggle) {
    toggleInput.checked = state.showLocked === true;
    toggleInput.addEventListener("change", function() {
      state.showLocked = toggleInput.checked === true;
      root.setAttribute("data-collection-show-locked", state.showLocked ? "true" : "false");
      renderCollection(state);
      announceCollectionState(state);
      scheduleSave(state, false);
    });
  }

  if (searchInput && state.searchable) {
    searchInput.addEventListener("input", function() {
      setCollectionFilterValue(state, "search", searchInput.value || "", COLLECTION_DEBOUNCE.searchInput);
    });
    searchInput.addEventListener("keydown", function(event) {
      if ((event.key || "").toLowerCase() !== "enter") return;
      event.preventDefault();
      setCollectionFilterValue(state, "search", searchInput.value || "", 0);
    });
    searchInput.addEventListener("blur", function() {
      setCollectionFilterValue(state, "search", searchInput.value || "", COLLECTION_DEBOUNCE.searchBlur);
    });
  }

  filterControls.forEach(function(ctrl) {
    ctrl.addEventListener("change", function() {
      var filterName = (ctrl.getAttribute("data-dashboard-filter") || "").trim();
      if (!filterName) return;
      setCollectionFilterValue(state, filterName, ctrl.value || "", COLLECTION_DEBOUNCE.filterApply);
    });
  });

  filterDialogBtns.forEach(function(btn) {
    btn.addEventListener("click", async function(event) {
      event.preventDefault();
      await openCollectionFilterDialog(btn, state);
    });
  });

  if (clearFiltersBtn) {
    clearFiltersBtn.addEventListener("click", function(event) {
      event.preventDefault();
      clearCollectionFilters(state);
    });
  }

  if (editToggleBtn && state.editable) {
    editToggleBtn.addEventListener("click", function(event) {
      event.preventDefault();
      setEditMode(state, !state.editMode);
    });
  }

  root.addEventListener("click", function(event) {
    handleCollectionClick(state, event);
  });

  root.addEventListener("focusin", function(event) {
    var card = event.target.closest("[data-collection-card='true']");
    if (!(card) || !(root.contains(card))) return;
    state.focusKey = (card.getAttribute("data-card-key") || "").toString().trim();
    syncFocusedCardState(state);
  });

  root.addEventListener("keydown", function(event) {
    handleCollectionKeydown(state, event);
  });

  root.addEventListener("pointerdown", function(event) {
    handlePointerDown(state, event);
  });

  root.addEventListener("ua:collection:toggle-edit", function(event) {
    var detail = (event && event.detail) || {};
    if (typeof detail.enabled === "boolean") {
      setEditMode(state, detail.enabled);
      return;
    }
    setEditMode(state, !state.editMode);
  });

  root.addEventListener("ua:collection:toggle-locked", function(event) {
    var detail = (event && event.detail) || {};
    if (typeof detail.enabled === "boolean") {
      state.showLocked = detail.enabled === true;
    } else {
      state.showLocked = !(state.showLocked === true);
    }
    root.setAttribute("data-collection-show-locked", state.showLocked ? "true" : "false");
    if (toggleInput) toggleInput.checked = state.showLocked === true;
    renderCollection(state);
    announceCollectionState(state);
    scheduleSave(state, false);
  });

  root.addEventListener("ua:collection:load", function(event) {
    var detail = (event && event.detail) || {};
    if (!(detail.items instanceof Array)) return;
    setCollectionItems(state, detail.items, {
      markPrefetched: true
    });
    resetRevealState(state);
    renderCollection(state);
    announceCollectionState(state);
  });

  if (window.IntersectionObserver && sentinel) {
    state.observer = new IntersectionObserver(function(entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          maybeAdvanceCollection(state);
        }
      }
    }, {
      rootMargin: "280px 0px 280px 0px",
      threshold: 0
    });
    state.observer.observe(sentinel);
  }

  if (hasApiSource(state)) {
    await loadApiSearch(state);
  } else {
    resetRevealState(state);
    renderCollection(state);
  }
  announceCollectionState(state);
}

function parseRevealSequence(raw) {
  var values = (raw || "25,25,30").toString().split(",").map(function(item) {
    return Math.max(1, Number((item || "").toString().trim()) || 0);
  }).filter(Boolean);
  if (values.length === 0) return [25, 25, 30];
  return values;
}

function parseDirectItems(scriptNode) {
  if (!(scriptNode)) return [];
  var raw = (scriptNode.textContent || "").toString().trim();
  if (!raw) return [];
  try {
    var parsed = JSON.parse(raw);
    return parsed instanceof Array ? parsed : [];
  } catch (error) {
    console.error("Unable to parse collection items JSON.", error);
    return [];
  }
}

function parseObjectAttr(raw) {
  var text = (raw || "").toString().trim();
  if (!text) return {};
  try {
    var parsed = JSON.parse(text);
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch (error) {
    console.error("Unable to parse collection config JSON.", error);
    return {};
  }
}

function normalizeFilterValue(value) {
  if (value instanceof Array) {
    return value.map(function(item) {
      return (item || "").toString().trim();
    }).filter(Boolean).join(",");
  }
  return (value || "").toString().trim();
}

function getCollectionSearchValue(state) {
  if (!(state && state.filters && typeof state.filters === "object")) return "";
  return normalizeFilterValue(state.filters.search || "");
}

function parseFilterValueList(value) {
  var text = normalizeFilterValue(value);
  if (!text) return [];
  return text.split(",").map(function(item) {
    return (item || "").toString().trim();
  }).filter(Boolean);
}

function refreshCollection(state) {
  resetRevealState(state);
  if (hasApiSource(state)) {
    state.cache = {};
    loadApiSearch(state);
    return;
  }
  renderCollection(state);
  syncArrangeFocusState(state);
}

function setCollectionFilterValue(state, filterName, value, delay) {
  if (!filterName) return;
  state.filters[filterName] = normalizeFilterValue(value);
  if (filterName === "search") {
    state.filters.search = state.filters[filterName];
  }

  var control = findCollectionFilterControl(state.root, filterName);
  if (control) control.value = state.filters[filterName];

  var dialogBtn = state.root.querySelector("button[data-dashboard-filter-dialog='true'][data-dashboard-filter-name='" + cssEscapeAttr(filterName) + "']");
  if (dialogBtn) dialogBtn.setAttribute("data-dashboard-filter-selected", state.filters[filterName]);

  var quickToggle = findCollectionQuickToggleElement(state.root, filterName);
  if (quickToggle) setButtonToggleValue(quickToggle, state.filters[filterName]);

  syncCollectionFilterButtonLabels(state.root, state.filters);
  renderCollectionActiveFilterRow(state);

  if (state.pendingFilterTimer) clearTimeout(state.pendingFilterTimer);
  state.pendingFilterTimer = setTimeout(function() {
    state.pendingFilterTimer = null;
    refreshCollection(state);
  }, Math.max(0, Number(delay) || 0));
}

function clearCollectionFilters(state) {
  state.filters = {};
  state.filters.search = "";

  var searchInput = state.root.querySelector("[data-collection-search='true']");
  if (searchInput) searchInput.value = "";

  state.root.querySelectorAll("input[type='hidden'][data-dashboard-filter]").forEach(function(ctrl) {
    ctrl.value = "";
    var filterName = (ctrl.getAttribute("data-dashboard-filter") || "").trim();
    if (filterName) state.filters[filterName] = "";
  });

  state.root.querySelectorAll("button[data-dashboard-filter-dialog='true']").forEach(function(btn) {
    btn.setAttribute("data-dashboard-filter-selected", "");
  });

  state.root.querySelectorAll("[data-ua-button-toggle='true'][data-toggle-name^='quick-toggle-']").forEach(function(toggleEl) {
    setButtonToggleValue(toggleEl, "");
  });

  syncCollectionFilterButtonLabels(state.root, state.filters);
  renderCollectionActiveFilterRow(state);
  if (state.pendingFilterTimer) clearTimeout(state.pendingFilterTimer);
  state.pendingFilterTimer = setTimeout(function() {
    state.pendingFilterTimer = null;
    refreshCollection(state);
  }, COLLECTION_DEBOUNCE.clearAll);
}

function parseFilterOptionsFromButton(btn) {
  if (!btn) return [];
  var raw = btn.getAttribute("data-dashboard-filter-options") || "[]";
  try {
    var parsed = JSON.parse(raw);
    if (!(parsed instanceof Array)) return [];
    return parsed.map(function(item) {
      return {
        value: ((item || {}).value || "").toString(),
        label: ((item || {}).label || (item || {}).value || "").toString(),
        description: ((item || {}).description || "").toString(),
        icon: ((item || {}).icon || "").toString(),
        thumbnail: ((item || {}).thumbnail || (item || {}).image || "").toString(),
        meta: ((item || {}).meta || "").toString(),
        badge: ((item || {}).badge || "").toString()
      };
    });
  } catch (error) {
    console.warn("Unable to parse collection filter options.", error);
    return [];
  }
}

function dialogFilterName(btn) {
  if (!btn) return "";
  return (btn.getAttribute("data-dashboard-filter-name") || btn.getAttribute("data-dashboard-filter") || "").trim();
}

function findCollectionFilterControl(root, filterName) {
  if (!(root)) return null;
  var escaped = cssEscapeAttr((filterName || "").toString());
  return root.querySelector("input[type='hidden'][data-dashboard-filter='" + escaped + "']");
}

function syncCollectionFilterButtonLabels(root, filters) {
  var stateFilters = filters || {};
  root.querySelectorAll("button[data-dashboard-filter-dialog='true']").forEach(function(btn) {
    var filterName = dialogFilterName(btn);
    var baseLabel = (btn.getAttribute("data-dashboard-filter-button-label") || btn.getAttribute("data-dashboard-filter-label") || "Filter").trim();
    var icon = (btn.getAttribute("data-dashboard-filter-icon") || "").trim();
    var iconOnly = (btn.getAttribute("data-dashboard-filter-icon-only") || "false").toString().trim().toLowerCase() === "true";
    var selectedValue = (stateFilters[filterName] || btn.getAttribute("data-dashboard-filter-selected") || "").toString();
    var selectedValues = parseFilterValueList(selectedValue);
    var options = parseFilterOptionsFromButton(btn);
    var labelMap = {};

    for (var i = 0; i < options.length; i++) {
      labelMap[options[i].value] = options[i].label;
    }

    var label = baseLabel;
    if (selectedValues.length === 1) label = baseLabel + ": " + (labelMap[selectedValues[0]] || selectedValues[0]);
    else if (selectedValues.length > 1) label = baseLabel + ": " + selectedValues.length + " selected";

    btn.setAttribute("title", label);
    btn.setAttribute("aria-label", label);
    if (iconOnly) {
      btn.innerHTML = icon ? ("<i class='" + escapeHtml(icon.indexOf("bi-") === 0 ? ("bi " + icon) : icon) + "'></i>") : "";
    } else {
      btn.innerHTML = (icon ? ("<i class='" + escapeHtml(icon.indexOf("bi-") === 0 ? ("bi " + icon) : icon) + "'></i> ") : "") + escapeHtml(label);
    }
  });
}

function renderCollectionActiveFilterRow(state) {
  if (!(state.activeFiltersRow && state.activeChipsHost)) return;

  var chips = [];
  var keys = Object.keys(state.filters || {});
  for (var i = 0; i < keys.length; i++) {
    var filterName = keys[i];
    var rawValue = normalizeFilterValue(state.filters[filterName]);
    if (!rawValue) continue;

    var dialogBtn = state.root.querySelector("button[data-dashboard-filter-dialog='true'][data-dashboard-filter-name='" + cssEscapeAttr(filterName) + "']");
    var isMulti = dialogBtn && (dialogBtn.getAttribute("data-dashboard-filter-multi") || "").toString().toLowerCase() === "true";
    var values = isMulti ? parseFilterValueList(rawValue) : [rawValue];
    var filterLabel = dialogBtn
      ? ((dialogBtn.getAttribute("data-dashboard-filter-label") || filterName).toString())
      : (filterName === "search" ? "Search" : filterName);
    var options = dialogBtn ? parseFilterOptionsFromButton(dialogBtn) : [];
    var labelMap = {};

    for (var opt = 0; opt < options.length; opt++) {
      labelMap[options[opt].value] = options[opt].label;
    }

    for (var v = 0; v < values.length; v++) {
      if (!values[v]) continue;
      chips.push({
        filterName: filterName,
        value: values[v],
        label: filterLabel + ": " + (labelMap[values[v]] || values[v])
      });
    }
  }

  state.activeChipsHost.innerHTML = chips.map(function(chip) {
    return "<button type='button' class='btn btn-outline-secondary btn-sm d-inline-flex align-items-center gap-1'" +
      " data-collection-filter-chip='true'" +
      " data-collection-filter-name='" + escapeHtml(chip.filterName) + "'" +
      " data-collection-filter-value='" + escapeHtml(chip.value) + "'>" +
      escapeHtml(chip.label) +
      "<i class='bi bi-x-lg'></i></button>";
  }).join("");

  var clearBtn = state.root.querySelector("[data-collection-clear-filters-row='true']");
  if (clearBtn) clearBtn.classList.toggle("d-none", chips.length < 3);

  var quickToggleCount = state.quickTogglesHost
    ? state.quickTogglesHost.querySelectorAll("[data-ua-button-toggle='true'][data-toggle-name^='quick-toggle-']").length
    : 0;
  state.activeFiltersRow.classList.toggle("d-none", chips.length === 0 && quickToggleCount === 0);
}

async function openCollectionFilterDialog(btn, state) {
  var filterName = dialogFilterName(btn);
  if (!filterName) return;

  var filterLabel = (btn.getAttribute("data-dashboard-filter-label") || "Filter").trim();
  var filterDescription = (btn.getAttribute("data-dashboard-filter-description") || "").toString().trim();
  var filterPreview = (btn.getAttribute("data-dashboard-filter-preview") || "text").toString().trim().toLowerCase();
  var filterMulti = (btn.getAttribute("data-dashboard-filter-multi") || "false").toString().trim().toLowerCase() === "true";
  var options = parseFilterOptionsFromButton(btn);
  var currentValue = (state.filters[filterName] || btn.getAttribute("data-dashboard-filter-selected") || "").toString();

  function applySelectedValue(selectedValue) {
    setCollectionFilterValue(state, filterName, selectedValue, COLLECTION_DEBOUNCE.filterApply);
  }

  if (!(window.UATools && typeof window.UATools.render === "function" && typeof window.UATools.save === "function" && typeof window.UATools.load === "function")) {
    var fallbackValue = window.prompt("Filter " + filterLabel + " (comma separated, blank for all):", currentValue);
    if (fallbackValue === null) return;
    applySelectedValue(fallbackValue);
    return;
  }

  var dialogId = "collection-filter-dialog-" + Date.now() + "-" + Math.floor(Math.random() * 1000);
  var initialValues = parseFilterValueList(currentValue);
  if (!filterMulti && initialValues.length > 1) initialValues.splice(1);
  var dialogJson = {
    n: "ua.dialog",
    id: dialogId,
    title: filterLabel,
    allowclose: true,
    fullscreen: false,
    inner: {
      n: "div",
      c: "p-2",
      i: [
        filterDescription ? { n: "p", c: "text-muted mb-2", i: filterDescription } : "",
        {
          n: "ua.select.multiple",
          name: dialogId + "__values",
          title: "",
          searchable: true,
          preview: filterPreview,
          options: options || [],
          value: initialValues
        }
      ]
    },
    footer: {
      n: "div",
      c: "d-flex justify-content-end",
      i: {
        n: "button",
        id: dialogId + "__done",
        type: "button",
        c: "btn btn-outline-secondary btn-sm",
        i: "Done"
      }
    }
  };

  try {
    var rendered = await window.UATools.render(dialogJson);
    var node = null;
    if (typeof rendered === "string") {
      var holder = document.createElement("div");
      holder.innerHTML = rendered;
      node = holder.firstElementChild;
    } else if (rendered && rendered.nodeType) {
      node = rendered;
    }
    if (!node) return;

    document.body.appendChild(node);
    if (typeof window.UATools.after === "function") window.UATools.after();

    var dialogHostName = dialogId;
    try {
      if (node.nodeType === 1 && node.tagName === "UAE") node.setAttribute("name", dialogHostName);
    } catch (error) {}
    var dialogHostSelector = "uae[name='" + cssEscapeAttr(dialogHostName) + "']";
    var controlUae = node.querySelector(".modal-body uae[name]");
    var resolvedControlName = controlUae ? (controlUae.getAttribute("name") || "").toString().trim() : "";
    if (!resolvedControlName) return;

    var loadObj = {};
    loadObj[resolvedControlName] = initialValues;
    await window.UATools.load(loadObj, dialogHostSelector);

    function closeDialog() {
      var dismissBtn = node.querySelector("[data-ua-dismiss='modal'],[data-bs-dismiss='modal']");
      if (dismissBtn && typeof dismissBtn.click === "function") dismissBtn.click();
    }

    async function saveAndApplyFilter() {
      var saveResult = await window.UATools.save(dialogHostSelector, true);
      if (!saveResult || saveResult.success === false) return false;
      var controlResult = saveResult[resolvedControlName];
      if (!controlResult || controlResult.success === false) return false;
      var selected = parseFilterValueList(controlResult.data || []);
      if (!filterMulti && selected.length > 1) selected.splice(1);
      applySelectedValue(selected.join(","));
      return true;
    }

    var applyDebounce = null;
    node.addEventListener("change", function() {
      if (applyDebounce) clearTimeout(applyDebounce);
      applyDebounce = setTimeout(async function() {
        try {
          await saveAndApplyFilter();
        } catch (saveError) {
          console.error("Collection filter apply failed:", saveError);
        }
      }, COLLECTION_DEBOUNCE.dialogSelect);
    });

    var doneBtn = node.querySelector("#" + dialogId + "__done");
    if (doneBtn) {
      doneBtn.addEventListener("click", function(event) {
        event.preventDefault();
        closeDialog();
      });
    }
  } catch (error2) {
    console.error("Collection filter dialog open failed:", error2);
  }
}

function normalizeToggleIcon(icon) {
  var text = (icon || "").toString().trim();
  if (!text) return "";
  if (text.indexOf("bi ") === 0) return text;
  if (text.indexOf("bi-") === 0) return "bi " + text;
  return text;
}

function parseButtonToggleOptions(toggleEl) {
  if (!toggleEl) return [];
  var raw = toggleEl.getAttribute("data-toggle-options") || "[]";
  try {
    var parsed = JSON.parse(raw);
    if (!(parsed instanceof Array)) return [];
    return parsed.map(function(item, index) {
      var row = item || {};
      var name = (row.name || row.value || row.id || ("option-" + index)).toString().trim();
      return {
        name: name,
        title: (row.title || row.label || name).toString(),
        icon: normalizeToggleIcon(row.icon || "")
      };
    }).filter(function(item) {
      return !!item.name;
    });
  } catch (error3) {
    console.warn("Unable to parse toggle options.", error3);
    return [];
  }
}

function getButtonToggleValue(toggleEl) {
  if (!toggleEl) return "";
  return normalizeFilterValue(toggleEl.getAttribute("data-toggle-value") || "");
}

function renderButtonToggleLabel(toggleEl, option) {
  if (!toggleEl || !option) return;
  var labelHost = toggleEl.querySelector("[data-toggle-label='true']");
  var mainBtn = toggleEl.querySelector("[data-toggle-main='true']");
  if (!labelHost || !mainBtn) return;

  var mode = (toggleEl.getAttribute("data-toggle-mode") || "icon-text").toString().trim().toLowerCase();
  var iconClass = normalizeToggleIcon(option.icon || "");
  var text = option.title || option.name;
  var html = "";

  if (mode === "icon") html = iconClass ? ("<i class='" + escapeHtml(iconClass) + "'></i>") : "";
  else if (mode === "text") html = escapeHtml(text);
  else if (iconClass) html = "<i class='" + escapeHtml(iconClass) + "'></i><span>" + escapeHtml(text) + "</span>";
  else html = escapeHtml(text);

  labelHost.innerHTML = html;
  mainBtn.setAttribute("title", text);
  mainBtn.setAttribute("aria-label", text);
}

function setButtonToggleValue(toggleEl, value) {
  if (!toggleEl) return;
  var desired = normalizeFilterValue(value);
  var options = parseButtonToggleOptions(toggleEl);
  if (!desired) {
    toggleEl.setAttribute("data-toggle-value", "");
    renderButtonToggleLabel(toggleEl, {
      name: "",
      title: (toggleEl.getAttribute("data-toggle-placeholder-title") || toggleEl.getAttribute("aria-label") || "Toggle").toString(),
      icon: (toggleEl.getAttribute("data-toggle-placeholder-icon") || "").toString()
    });
    return;
  }

  var match = null;
  for (var i = 0; i < options.length; i++) {
    if (options[i].name === desired) {
      match = options[i];
      break;
    }
  }
  if (!match && options.length > 0) match = options[0];
  if (!match) return;

  toggleEl.setAttribute("data-toggle-value", match.name);
  renderButtonToggleLabel(toggleEl, match);
}

function cycleButtonToggleValue(toggleEl) {
  var options = parseButtonToggleOptions(toggleEl);
  if (options.length === 0) return "";
  var current = getButtonToggleValue(toggleEl);
  var idx = 0;
  for (var i = 0; i < options.length; i++) {
    if (options[i].name === current) {
      idx = i;
      break;
    }
  }
  var next = options[(idx + 1) % options.length];
  setButtonToggleValue(toggleEl, next.name);
  return next.name;
}

function bindButtonToggle(toggleEl, handlers) {
  if (!toggleEl) return;
  if (toggleEl.getAttribute("data-toggle-bound") === "true") return;
  toggleEl.setAttribute("data-toggle-bound", "true");

  var onChange = handlers && typeof handlers.onChange === "function" ? handlers.onChange : null;
  var onSettings = handlers && typeof handlers.onSettings === "function" ? handlers.onSettings : null;

  toggleEl.addEventListener("click", function(event) {
    var settingsBtn = event.target.closest("[data-toggle-settings='true']");
    if (settingsBtn && toggleEl.contains(settingsBtn)) {
      event.preventDefault();
      if (onSettings) onSettings();
      return;
    }

    var mainBtn = event.target.closest("[data-toggle-main='true']");
    if (!mainBtn || !toggleEl.contains(mainBtn)) return;
    event.preventDefault();

    var options = parseButtonToggleOptions(toggleEl);
    if (options.length === 0) return;
    var nextValue = cycleButtonToggleValue(toggleEl);
    if (onChange) onChange(nextValue);
  });
}

async function openButtonToggleDialog(toggleEl, onSelect) {
  if (!(toggleEl) || typeof onSelect !== "function") return;
  var options = parseButtonToggleOptions(toggleEl);
  if (options.length === 0) return;
  var currentValue = getButtonToggleValue(toggleEl);
  var title = (toggleEl.getAttribute("aria-label") || toggleEl.getAttribute("data-toggle-name") || "Select option").toString();

  if (!(window.UATools && typeof window.UATools.render === "function" && typeof window.UATools.save === "function" && typeof window.UATools.load === "function")) {
    var promptText = "Choose one: " + options.map(function(option) { return option.name; }).join(", ");
    var fallbackValue = window.prompt(promptText, currentValue || options[0].name);
    if (fallbackValue === null) return;
    onSelect((fallbackValue || "").toString().trim());
    return;
  }

  var dialogId = "toggle-settings-" + Date.now() + "-" + Math.floor(Math.random() * 1000);
  var dialogJson = {
    n: "ua.dialog",
    id: dialogId,
    title: title,
    allowclose: true,
    fullscreen: false,
    inner: {
      n: "div",
      c: "p-2",
      i: {
        n: "ua.select.multiple",
        name: dialogId + "__value",
        title: "",
        searchable: true,
        preview: "text",
        options: options.map(function(option) {
          return {
            value: option.name,
            label: option.title,
            icon: option.icon
          };
        }),
        value: currentValue ? [currentValue] : []
      }
    }
  };

  try {
    var rendered = await window.UATools.render(dialogJson);
    var node = null;
    if (typeof rendered === "string") {
      var holder = document.createElement("div");
      holder.innerHTML = rendered;
      node = holder.firstElementChild;
    } else if (rendered && rendered.nodeType) {
      node = rendered;
    }
    if (!node) return;

    document.body.appendChild(node);
    if (typeof window.UATools.after === "function") window.UATools.after();

    var dialogHostName = dialogId;
    try {
      if (node.tagName === "UAE") node.setAttribute("name", dialogHostName);
    } catch (error4) {}
    var dialogHostSelector = "uae[name='" + cssEscapeAttr(dialogHostName) + "']";
    var controlUae = node.querySelector(".modal-body uae[name]");
    var resolvedControlName = controlUae ? (controlUae.getAttribute("name") || "").toString().trim() : "";
    if (!resolvedControlName) return;

    var payload = {};
    payload[resolvedControlName] = currentValue ? [currentValue] : [];
    await window.UATools.load(payload, dialogHostSelector);

    var saveDebounce = null;
    node.addEventListener("change", function() {
      if (saveDebounce) clearTimeout(saveDebounce);
      saveDebounce = setTimeout(function() {
        (async function() {
          try {
            var saveResult = await window.UATools.save(dialogHostSelector, true);
            if (!saveResult || saveResult.success === false) return;
            var controlResult = saveResult[resolvedControlName];
            if (!controlResult || controlResult.success === false) return;
            var selected = parseFilterValueList(controlResult.data || []);
            var nextValue = (selected[0] || "").toString();
            if (!nextValue) return;
            onSelect(nextValue);
            var dismissBtn = node.querySelector("[data-ua-dismiss='modal'],[data-bs-dismiss='modal']");
            if (dismissBtn && typeof dismissBtn.click === "function") dismissBtn.click();
          } catch (saveError) {
            console.error("Toggle settings dialog save failed:", saveError);
          }
        })();
      }, 120);
    });
  } catch (error5) {
    console.error("Toggle settings dialog failed:", error5);
  }
}

function quickToggleFilterName(toggleEl) {
  if (!toggleEl) return "";
  var toggleName = (toggleEl.getAttribute("data-toggle-name") || "").toString().trim();
  if (toggleName.indexOf("quick-toggle-") !== 0) return "";
  return toggleName.substring("quick-toggle-".length).trim();
}

function findCollectionQuickToggleElement(root, filterName) {
  if (!(root) || !filterName) return null;
  return root.querySelector("[data-ua-button-toggle='true'][data-toggle-name='quick-toggle-" + cssEscapeAttr(filterName) + "']");
}

function normalizeItems(items) {
  var list = items instanceof Array ? items.slice() : [];
  var normalized = list.map(function(item, index) {
    return normalizeItem(item, index);
  }).filter(Boolean);

  normalized.sort(function(left, right) {
    var leftLocked = left.locked === true ? 0 : 1;
    var rightLocked = right.locked === true ? 0 : 1;
    if (leftLocked !== rightLocked) return leftLocked - rightLocked;
    if (left.order !== right.order) return left.order - right.order;
    return (left.key || "").localeCompare(right.key || "");
  });

  for (var i = 0; i < normalized.length; i++) {
    normalized[i].order = i + 1;
  }

  return normalized;
}

function applySequentialOrder(items) {
  var list = items instanceof Array ? items.slice() : [];
  return list.map(function(item, index) {
    var next = item && typeof item === "object" ? { ...item } : {};
    next.order = index + 1;
    if (next.saveData && typeof next.saveData === "object") {
      next.saveData = { ...next.saveData, order: index + 1 };
    }
    return next;
  });
}

function setCollectionItems(state, items, options) {
  var normalized = normalizeItems(items);
  state.directItems = normalized.slice();
  state.items = normalized.slice();

  if (hasApiSource(state)) {
    var result = getResultState(state);
    result.items = normalized.slice();
    result.total = normalized.length;
    if (options && options.markPrefetched === true) {
      result.prefetched = true;
      result.exhausted = true;
    }
  }

  return normalized;
}

function normalizeItem(item, index) {
  if (!(item && typeof item === "object")) return null;
  var key = (item.key || item.id || item.namespace || ("item-" + index)).toString().trim();
  if (!key) key = "item-" + index;
  var size = (item.size || item.cardSize || "regular").toString().trim().toLowerCase();
  if (["small", "regular", "large", "full"].indexOf(size) < 0) size = "regular";
  return {
    key: key,
    id: (item.id || key).toString(),
    title: (item.title || item.label || key).toString(),
    description: (item.description || item.subtitle || "").toString(),
    icon: normalizeIconClass(item.icon || "bi-grid"),
    route: (item.route || item.href || "").toString(),
    badge: (item.badge || "").toString(),
    meta: (item.meta || "").toString(),
    overline: (item.overline || "").toString(),
    thumbnail: (item.thumbnail || item.image || item.thumb || "").toString(),
    size: size,
    locked: item.locked === true,
    lockAdornment: item.lockAdornment === true,
    removable: item.removable !== false,
    kind: (item.kind || item.type || "item").toString(),
    preview: item.preview && typeof item.preview === "object" ? { ...item.preview } : null,
    cardMode: (item.cardMode || "").toString().trim().toLowerCase(),
    iconAdornment: item.iconAdornment && typeof item.iconAdornment === "object" ? { ...item.iconAdornment } : null,
    order: Number(item.order) || (index + 1),
    actionButtons: item.actionButtons instanceof Array ? item.actionButtons : [],
    saveData: item.saveData && typeof item.saveData === "object" ? { ...item.saveData } : { ...item }
  };
}

function normalizeIconClass(icon) {
  var text = (icon || "").toString().trim();
  if (!text) return "bi bi-grid";
  if (text.indexOf("bi ") === 0) return text;
  if (text.indexOf("bi-") === 0) return "bi " + text;
  return text;
}

function hasApiSource(state) {
  return !!(state && state.pageNamespace && state.dashboardApi);
}

function getCacheKey(state) {
  var filterKeys = Object.keys(state.filters || {}).sort();
  var normalized = {};
  for (var i = 0; i < filterKeys.length; i++) {
    normalized[filterKeys[i]] = normalizeFilterValue(state.filters[filterKeys[i]]);
  }
  return JSON.stringify({
    search: getCollectionSearchValue(state).toLowerCase(),
    filters: normalized
  });
}

function getResultState(state) {
  var key = getCacheKey(state);
  if (!state.cache[key]) {
    state.cache[key] = {
      items: [],
      total: 0,
      nextPage: 1,
      loading: false,
      exhausted: false,
      visibleCount: 0,
      revealStep: 0,
      prefetched: false
    };
  }
  return state.cache[key];
}

function resetRevealState(state) {
  var result = getResultState(state);
  result.visibleCount = 0;
  result.revealStep = 0;
  if (!(hasApiSource(state))) {
    result.items = state.directItems.slice();
    result.total = result.items.length;
    result.nextPage = 1;
    result.exhausted = true;
  }
  bumpVisibleCount(state, result);
}

function bumpVisibleCount(state, result) {
  var count = state.revealSequence[Math.min(result.revealStep, state.revealSequence.length - 1)] || state.apiPageSize;
  if (result.revealStep >= state.revealSequence.length) count = state.apiPageSize;
  result.revealStep += 1;
  result.visibleCount = Math.min(result.total || result.items.length, result.visibleCount + count);
}

async function loadApiSearch(state) {
  var result = getResultState(state);
  if (result.loading) return;
  if (!result.prefetched) {
    await preloadInitialPages(state, result);
  }
  if (result.visibleCount === 0) {
    bumpVisibleCount(state, result);
  }
  renderCollection(state);
}

async function preloadInitialPages(state, result) {
  result.loading = true;
  setStatus(state, "Loading items...", false, false);
  try {
    for (var page = 1; page <= 3; page++) {
      if (result.exhausted) break;
      await loadNextApiPage(state, result, page === 1 ? false : true);
    }
    result.prefetched = true;
  } finally {
    result.loading = false;
  }
}

async function loadNextApiPage(state, result, silent) {
  if (!(state.dashboardApi)) return;
  if (result.loading && silent !== true) return;
  if (result.exhausted) return;

  result.loading = true;
  if (silent !== true) setStatus(state, "Loading more items...", false, false);

  try {
    var filters = { ...state.apiFilters, ...state.filters };
    filters.search = getCollectionSearchValue(state);

    var response = state.apiUrl
      ? await state.dashboardApi.withBase(state.apiUrl).list(filters, result.nextPage, {}, state.apiPageSize)
      : await state.dashboardApi.list(state.pageNamespace, filters, result.nextPage, {}, state.apiPageSize);

    if (!(response && response.success)) {
      setStatus(state, "Unable to load items.", true, false);
      return;
    }

    var data = response.data || {};
    var rows = data.rows instanceof Array ? data.rows : [];
    var normalizedRows = normalizeItems(rows);
    result.items = result.items.concat(normalizedRows);
    result.total = Math.max(Number(data.total) || result.items.length, result.items.length);
    result.nextPage += 1;
    if (rows.length < state.apiPageSize || result.items.length >= result.total) {
      result.exhausted = true;
    }
    state.items = result.items.slice();
    if (state.editable || state.saveMode === "dashboard-save") {
      state.directItems = result.items.slice();
    }
    clearStatus(state, silent !== true);
  } catch (error) {
    console.error("Collection API load failed.", error);
    setStatus(state, "Unable to load items.", true, false);
  } finally {
    result.loading = false;
  }
}

function setStatus(state, message, isError, autoClear) {
  if (!(state && state.statusNode)) return;
  if (state.clearStatusTimer) clearTimeout(state.clearStatusTimer);
  state.statusNode.className = "ua-collection-order-status" + (isError ? " text-danger" : "");
  if (message && typeof message === "object") {
    var messageText = (message.text || "").toString();
    var closeLabel = (message.closeLabel || "Exit arrange mode").toString();
    state.statusNode.innerHTML =
      "<span class='ua-collection-order-status-copy'>" + escapeHtml(messageText) + "</span>" +
      (message.closeEdit === true
        ? ("<button type='button' class='ua-collection-order-status-close' data-collection-close-edit='true' title='" + escapeHtml(closeLabel) + "' aria-label='" + escapeHtml(closeLabel) + "'><i class='bi bi-x-lg'></i></button>")
        : "");
  } else {
    state.statusNode.textContent = (message || "").toString();
  }
  if (autoClear !== false && message) {
    state.clearStatusTimer = setTimeout(function() {
      state.clearStatusTimer = null;
      clearStatus(state, false);
    }, STATUS_CLEAR_MS);
  }
}

function clearStatus(state, autoClear) {
  if (!(state && state.statusNode)) return;
  if (autoClear === true) {
    setStatus(state, "", false, false);
    return;
  }
  state.statusNode.className = "ua-collection-order-status";
  state.statusNode.innerHTML = "";
}

function getVisibleItems(state) {
  var result = getResultState(state);
  var items = hasApiSource(state) ? result.items.slice() : state.directItems.slice();
  items = applyCollectionFilters(state, items);
  if (!(hasApiSource(state))) result.total = items.length;
  return items.slice(0, Math.max(0, result.visibleCount || 0));
}

function getRenderableItems(state) {
  var items = getVisibleItems(state);
  if (!(state && state.drag && state.drag.activated)) return items;
  return buildDragPreviewItems(state, items);
}

function buildDragPreviewItems(state, items) {
  var rows = items instanceof Array ? items.slice() : [];
  var drag = state.drag || {};
  var movingKey = (drag.key || "").toString();
  if (!movingKey) return rows;

  var locked = rows.filter(function(item) {
    return item && item.locked === true;
  });
  var unlocked = rows.filter(function(item) {
    return item && item.locked !== true;
  });
  var movingIndex = unlocked.findIndex(function(item) {
    return item && item.key === movingKey;
  });
  if (movingIndex < 0) return rows;

  var movingItem = unlocked.splice(movingIndex, 1)[0];
  var insertIndex = Number.isFinite(drag.dropIndex) && drag.dropIndex >= 0
    ? drag.dropIndex
    : movingIndex;

  insertIndex = Math.max(0, Math.min(unlocked.length, insertIndex));
  unlocked.splice(insertIndex, 0, {
    key: "__drag-placeholder__",
    isPlaceholder: true,
    size: movingItem.size || drag.size || "regular",
    placeholderHeight: drag.placeholderHeight || 0
  });

  return locked.concat(unlocked);
}

function getFilteredTotal(state) {
  var result = getResultState(state);
  var items = hasApiSource(state) ? result.items.slice() : state.directItems.slice();
  items = applyCollectionFilters(state, items);
  return items.length;
}

function applyCollectionFilters(state, items) {
  var rows = items instanceof Array ? items.slice() : [];

  if (!state.showLocked) {
    rows = rows.filter(function(item) {
      return item.locked !== true;
    });
  }

  var searchValue = getCollectionSearchValue(state);
  if (searchValue) {
    rows = rows.filter(function(item) {
      var haystack = [
        item.title,
        item.description,
        item.meta,
        item.overline,
        item.kind,
        item.scope
      ].join(" ").toLowerCase();
      return haystack.indexOf(searchValue.toLowerCase()) >= 0;
    });
  }

  var filterKeys = Object.keys(state.filters || {});
  for (var i = 0; i < filterKeys.length; i++) {
    var filterName = filterKeys[i];
    if (filterName === "search") continue;
    var rawValue = normalizeFilterValue(state.filters[filterName]);
    if (!rawValue) continue;
    var values = parseFilterValueList(rawValue);

    rows = rows.filter(function(item) {
      for (var v = 0; v < values.length; v++) {
        if (matchesCollectionFilter(item, filterName, values[v])) return true;
      }
      return false;
    });
  }

  return rows;
}

function matchesCollectionFilter(item, filterName, value) {
  var normalizedValue = normalizeFilterValue(value).toLowerCase();
  if (!normalizedValue || normalizedValue === "all") return true;
  if (!(item && typeof item === "object")) return false;

  if (filterName === "kind" || filterName === "type") {
    return normalizeFilterValue(item.kind || item.type).toLowerCase() === normalizedValue;
  }

  if (filterName === "scope") {
    var itemScope = normalizeFilterValue(item.scope).toLowerCase();
    if (normalizedValue === "locked") return itemScope === "default";
    if (normalizedValue === "user" || normalizedValue === "personal") return itemScope === "user";
    return itemScope === normalizedValue;
  }

  var fieldValue = item[filterName];
  if (fieldValue instanceof Array) {
    return fieldValue.map(function(entry) {
      return normalizeFilterValue(entry).toLowerCase();
    }).indexOf(normalizedValue) >= 0;
  }

  return normalizeFilterValue(fieldValue).toLowerCase() === normalizedValue;
}

function renderCollection(state) {
  if (!(state && state.grid && state.sentinel)) return;
  var items = getRenderableItems(state);
  var total = getFilteredTotal(state);
  var html = items.map(function(item) {
    return renderItemCard(state, item);
  }).join("");

  state.grid.innerHTML = html +
    "<div class='ua-collection-order-empty" + (items.length === 0 ? "" : " d-none") + "' data-collection-empty='true'>" + escapeHtml(state.emptyMessage) + "</div>" +
    "<div class='ua-collection-order-sentinel' data-collection-sentinel='true'></div>";

  state.emptyNode = state.grid.querySelector("[data-collection-empty='true']");
  state.sentinel = state.grid.querySelector("[data-collection-sentinel='true']");
  if (state.observer && state.sentinel) {
    state.observer.disconnect();
    state.observer.observe(state.sentinel);
  }

  if (editToggleLabel(state)) {
    editToggleLabel(state).innerHTML = state.editMode
      ? "<i class='bi bi-x-lg'></i>"
      : "<i class='bi bi-pencil-square'></i>";
    editToggleLabel(state).classList.remove("btn-outline-secondary", "btn-primary");
    editToggleLabel(state).classList.add(state.editMode ? "btn-primary" : "btn-outline-secondary");
    editToggleLabel(state).setAttribute("title", state.editMode ? "Exit arrange mode" : rootEditLabel(state));
    editToggleLabel(state).setAttribute("aria-label", state.editMode ? "Exit arrange mode" : rootEditLabel(state));
  }

  if (total === 0) {
    clearDragState(state);
  }

  syncFocusedCardState(state);
  refreshDragLayout(state);
}

function renderItemCard(state, item) {
  if (item && item.isPlaceholder === true) {
    var placeholderHeight = Math.max(120, Number(item.placeholderHeight) || 0);
    return "<div class='ua-collection-order-card-wrap' data-card-size='" + escapeHtml(item.size || "regular") + "' data-card-placeholder='true'>" +
      "<div class='ua-collection-order-drop-slot' style='min-height:" + escapeHtml(placeholderHeight.toString()) + "px;' aria-hidden='true'></div>" +
      "</div>";
  }

  var locked = item.locked === true;
  var cardMode = (item.cardMode || "").toString().trim().toLowerCase();
  var isFocused = state.focusKey && state.focusKey === item.key;
  var icon = item.thumbnail
    ? "<img src='" + escapeHtml(item.thumbnail) + "' alt='' loading='lazy' style='width:100%;height:100%;object-fit:cover;border-radius:inherit;'/>"
    : ("<i class='" + escapeHtml(item.icon || "bi bi-grid") + "'></i>");
  var iconAdornment = item.iconAdornment && typeof item.iconAdornment === "object"
    ? "<span class='ua-collection-order-icon-adornment' title='" + escapeHtml((item.iconAdornment.title || "").toString()) + "'><i class='" + escapeHtml(normalizeIconClass(item.iconAdornment.icon || "bi-globe2")) + "'></i></span>"
    : "";
  var routeButton = item.route && !state.editMode
    ? "<a href='" + escapeHtml(item.route) + "' class='btn btn-sm btn-outline-secondary ua-collection-order-open-link' data-collection-open='true' title='Open' aria-label='Open'><i class='bi bi-arrow-up-right me-1'></i><span>Open</span></a>"
    : "";

  var pinActions = [];
  var otherActions = [];
  item.actionButtons.forEach(function(action) {
    if (isPinAction(action)) pinActions.push(action);
    else otherActions.push(action);
  });

  var showPinActions = pinActions.length > 0 && (state.pinVisibility === "always" || state.editMode === true);
  var topAdornmentActions = showPinActions ? pinActions : [];
  var topAdornmentHtml = topAdornmentActions.length > 0
    ? ("<div class='ua-collection-order-adornment-actions' data-adornment-position='top'>" + topAdornmentActions.map(function(action) {
      return renderActionButton(action, item.key);
    }).join("") + "</div>")
    : "";
  var itemActions = otherActions.map(function(action) {
    return renderActionButton(action, item.key);
  }).join("");

  var editActions = "";
  if (state.editMode) {
    if (state.showRemoveButton !== false && !locked && item.actionButtons.length === 0) {
      editActions = item.removable !== false
        ? ("<div class='ua-collection-order-edit-actions'>" +
          "<button type='button' class='btn btn-sm btn-outline-danger' data-collection-remove='true' data-collection-card-key='" + escapeHtml(item.key) + "' title='Remove'><i class='bi bi-x-lg'></i></button>" +
          "</div>")
        : "";
    }
  }

  var hasPreviewBottomAdornment = cardMode === "preview" && !!(itemActions || routeButton || editActions);
  var previewBottomAdornmentHtml = hasPreviewBottomAdornment
    ? ("<div class='ua-collection-order-adornment-actions' data-adornment-position='bottom'>" +
      itemActions +
      routeButton +
      editActions +
      "</div>")
    : "";

  var actionRow = (cardMode !== "preview" && (itemActions || routeButton || editActions))
    ? ("<div class='ua-collection-order-actions'>" +
      "<div class='ua-collection-order-primary-actions'>" + itemActions + "</div>" +
      "<div class='ua-collection-order-secondary-actions'>" + routeButton + editActions + "</div>" +
      "</div>")
    : "";

  if (cardMode === "preview") {
    return "<div class='ua-collection-order-card-wrap' data-card-size='" + escapeHtml(item.size || "regular") + "' data-card-key='" + escapeHtml(item.key) + "' data-card-locked='" + (locked ? "true" : "false") + "' data-card-focused='" + (isFocused ? "true" : "false") + "'>" +
      "<article class='ua-collection-order-card' data-collection-card='true' data-card-key='" + escapeHtml(item.key) + "' data-card-mode='preview' data-card-locked='" + (locked ? "true" : "false") + "' data-card-editing='" + (state.editMode ? "true" : "false") + "' data-card-has-top-adornment='" + (topAdornmentActions.length > 0 ? "true" : "false") + "' data-card-has-bottom-adornment='" + (hasPreviewBottomAdornment ? "true" : "false") + "'" + (state.editMode && !locked ? " tabindex='0'" : "") + (item.route && !state.editMode ? (" data-collection-route='" + escapeHtml(item.route) + "'") : "") + ">" +
      ((locked || item.lockAdornment === true) ? "<span class='ua-collection-order-lock' title='Locked item'><i class='bi bi-lock-fill'></i></span>" : "") +
      topAdornmentHtml +
      renderPreview(item.preview, previewBottomAdornmentHtml, item.title, item.badge) +
      "</article></div>";
  }

  return "<div class='ua-collection-order-card-wrap' data-card-size='" + escapeHtml(item.size || "regular") + "' data-card-key='" + escapeHtml(item.key) + "' data-card-locked='" + (locked ? "true" : "false") + "' data-card-focused='" + (isFocused ? "true" : "false") + "'>" +
    "<article class='ua-collection-order-card' data-collection-card='true' data-card-key='" + escapeHtml(item.key) + "' data-card-mode='regular' data-card-locked='" + (locked ? "true" : "false") + "' data-card-editing='" + (state.editMode ? "true" : "false") + "' data-card-has-top-adornment='" + (topAdornmentActions.length > 0 ? "true" : "false") + "'" + (state.editMode && !locked ? " tabindex='0'" : "") + (item.route && !state.editMode ? (" data-collection-route='" + escapeHtml(item.route) + "'") : "") + ">" +
    ((locked || item.lockAdornment === true) ? "<span class='ua-collection-order-lock' title='Locked item'><i class='bi bi-lock-fill'></i></span>" : "") +
    topAdornmentHtml +
    "<div class='ua-collection-order-card-top'>" +
    "<div class='ua-collection-order-icon'>" + icon +
    iconAdornment +
    "</div>" +
    "<div class='ua-collection-order-card-copy'>" +
    (item.overline ? ("<div class='ua-collection-order-overline'>" + escapeHtml(item.overline) + "</div>") : "") +
    "<div class='ua-collection-order-title-row'><h3 class='ua-collection-order-title'>" + escapeHtml(item.title) + "</h3>" +
    (item.badge ? ("<span class='ua-collection-order-badge'>" + escapeHtml(item.badge) + "</span>") : "") +
    "</div>" +
    (item.description ? ("<p class='ua-collection-order-description'>" + escapeHtml(item.description) + "</p>") : "") +
    "</div>" +
    "</div>" +
    renderPreview(item.preview) +
    (item.meta ? ("<div class='ua-collection-order-meta'>" + escapeHtml(item.meta) + "</div>") : "") +
    actionRow +
    "</article></div>";
}

function renderActionButton(action, itemKey) {
    var payload = action && action.data && typeof action.data === "object" ? { ...action.data } : {};
    var actionName = (action.action || "").toString().trim();
    var actionTitle = (action.title || action.label || actionName || "Action").toString().trim();
    payload.action = actionName || payload.action;
    var iconClass = action.icon ? normalizeIconClass(action.icon) : "";
    return "<button type='button' class='" + escapeHtml((action.className || "btn btn-sm btn-outline-secondary").toString()) + "'" +
      " data-collection-action='true'" +
      " data-collection-action-name='" + escapeHtml(actionName) + "'" +
      " data-collection-action-payload='" + escapeHtml(JSON.stringify(payload)) + "'" +
      " data-collection-card-key='" + escapeHtml(itemKey || "") + "'" +
      " title='" + escapeHtml(actionTitle) + "'" +
      " aria-label='" + escapeHtml(actionTitle) + "'>" +
      (iconClass ? ("<i class='" + escapeHtml(iconClass + (action.label ? " me-1" : "")) + "'></i>") : "") +
      escapeHtml((action.label || "").toString()) +
      "</button>";
}

function isPinAction(action) {
  var actionName = (((action || {}).action) || "").toString().trim().toLowerCase();
  return actionName === "add-widget" ||
    actionName === "remove-widget" ||
    actionName === "pin-dashboard" ||
    actionName === "remove-dashboard";
}

function renderPreview(preview, extraHtml, fallbackTitle, badge) {
  var trailing = extraHtml || "";
  var badgeHtml = badge ? ("<span class='ua-collection-order-badge'>" + escapeHtml(badge) + "</span>") : "";
  if (!(preview && typeof preview === "object")) {
    return trailing;
  }
  var kind = (preview.kind || "").toString();
  if (kind === "metric") {
    var metricSegments = preview.segments instanceof Array ? preview.segments : [];
    var metricToneMap = {
      primary: "bg-primary",
      info: "bg-info",
      warning: "bg-warning",
      success: "bg-success",
      danger: "bg-danger",
      secondary: "bg-secondary"
    };
    var metricBarHtml = "";
    var metricLegendHtml = "";

    for (var metricIndex = 0; metricIndex < metricSegments.length; metricIndex += 1) {
      var metricSegment = metricSegments[metricIndex] || {};
      var metricPercent = Math.max(0, Math.min(100, Number(metricSegment.percent || 0)));
      var metricToneClass = metricToneMap[(metricSegment.tone || "").toString().trim().toLowerCase()] || "bg-primary";

      if (metricPercent > 0) {
        metricBarHtml += "<div class='progress-bar " + metricToneClass + "' role='progressbar' style='width:" + escapeHtml(metricPercent.toFixed(2)) + "%;' aria-valuenow='" + escapeHtml(metricPercent.toFixed(2)) + "' aria-valuemin='0' aria-valuemax='100' title='" + escapeHtml((metricSegment.label || "") + " " + Number(metricPercent.toFixed(1)).toString() + "%") + "'></div>";
      }

      metricLegendHtml += "<div class='d-flex align-items-center gap-2 min-w-0'>" +
        "<span class='d-inline-block rounded-circle " + metricToneClass + "' style='width:.5rem;height:.5rem;flex:0 0 auto;'></span>" +
        "<span class='ua-collection-order-preview-label' style='text-transform:none;letter-spacing:0;'>" + escapeHtml(metricSegment.label || "") + "</span>" +
        "</div>";
    }

    return "<div class='ua-collection-order-preview' data-preview-kind='metric'>" +
      (badgeHtml ? ("<div class='d-flex justify-content-end mb-2'>" + badgeHtml + "</div>") : "") +
      "<div class='ua-collection-order-preview-value'>" + escapeHtml(preview.value || "0") + "</div>" +
      "<div class='ua-collection-order-preview-label'>" + escapeHtml(preview.label || "") + "</div>" +
      (metricBarHtml
        ? ("<div class='progress mt-2' style='height:.45rem;' aria-label='" + escapeHtml(preview.label || "Metric breakdown") + "'>" + metricBarHtml + "</div>")
        : "") +
      (metricLegendHtml
        ? ("<div class='d-flex flex-wrap gap-2 mt-2'>" + metricLegendHtml + "</div>")
        : "") +
      trailing +
      "</div>";
  }
  if (kind === "app") {
    return "<div class='ua-collection-order-preview' data-preview-kind='app'>" +
      (badgeHtml ? ("<div class='d-flex justify-content-end mb-2'>" + badgeHtml + "</div>") : "") +
      "<div class='ua-collection-order-preview-label'>" + escapeHtml(preview.label || "App") + "</div>" +
      "<div class='ua-collection-order-preview-value is-app'>" + escapeHtml(preview.value || "App") + "</div>" +
      trailing +
      "</div>";
  }
  if (kind === "storage") {
    var usedPercent = Math.max(0, Math.min(100, Number(preview.usedPercent || 0)));
    var freePercent = Math.max(0, 100 - usedPercent);
    var totalLabel = preview.totalValue
      ? ("Total Capacity: " + escapeHtml(preview.totalValue))
      : "";

    return "<div class='ua-collection-order-preview' data-preview-kind='storage'>" +
      (badgeHtml ? ("<div class='d-flex justify-content-end mb-2'>" + badgeHtml + "</div>") : "") +
      "<div class='d-flex justify-content-between align-items-end gap-3'>" +
      "<div class='min-w-0'>" +
      "<div class='ua-collection-order-preview-label'>Used</div>" +
      "<div class='ua-collection-order-preview-value'>" + escapeHtml(preview.usedValue || "0 B") + "</div>" +
      "</div>" +
      "<div class='min-w-0 text-end'>" +
      "<div class='ua-collection-order-preview-label'>Free</div>" +
      "<div class='ua-collection-order-preview-value'>" + escapeHtml(preview.freeValue || "0 B") + "</div>" +
      "</div>" +
      "</div>" +
      "<div class='progress' style='height:.55rem;' aria-label='Storage usage'>" +
      "<div class='progress-bar bg-primary' role='progressbar' style='width:" + escapeHtml(usedPercent.toFixed(2)) + "%;' aria-valuenow='" + escapeHtml(usedPercent.toFixed(2)) + "' aria-valuemin='0' aria-valuemax='100'></div>" +
      (freePercent > 0
        ? ("<div class='progress-bar bg-light text-dark' role='progressbar' style='width:" + escapeHtml(freePercent.toFixed(2)) + "%;' aria-valuenow='" + escapeHtml(freePercent.toFixed(2)) + "' aria-valuemin='0' aria-valuemax='100'></div>")
        : "") +
      "</div>" +
      "<div class='d-flex justify-content-between gap-3'>" +
      "<div class='ua-collection-order-preview-label'>" + escapeHtml(Number(usedPercent.toFixed(1)).toString()) + "% used</div>" +
      "<div class='ua-collection-order-preview-label'>" + totalLabel + "</div>" +
      "</div>" +
      trailing +
      "</div>";
  }
  if (kind === "segments") {
    var segmentList = preview.segments instanceof Array ? preview.segments : [];
    var toneMap = {
      primary: "bg-primary",
      info: "bg-info",
      warning: "bg-warning",
      success: "bg-success",
      danger: "bg-danger",
      secondary: "bg-secondary"
    };
    var barHtml = "";
    var rowsHtml = "";

    for (var index = 0; index < segmentList.length; index += 1) {
      var segment = segmentList[index] || {};
      var segmentPercent = Math.max(0, Math.min(100, Number(segment.percent || 0)));
      var toneClass = toneMap[(segment.tone || "").toString().trim().toLowerCase()] || "bg-primary";

      if (segmentPercent > 0) {
        barHtml += "<div class='progress-bar " + toneClass + "' role='progressbar' style='width:" + escapeHtml(segmentPercent.toFixed(2)) + "%;' aria-valuenow='" + escapeHtml(segmentPercent.toFixed(2)) + "' aria-valuemin='0' aria-valuemax='100' title='" + escapeHtml((segment.label || "") + " " + Number(segmentPercent.toFixed(1)).toString() + "%") + "'></div>";
      }

      rowsHtml += "<div class='d-flex justify-content-between align-items-center gap-2'>" +
        "<div class='d-flex align-items-center gap-2 min-w-0'>" +
        "<span class='d-inline-block rounded-circle " + toneClass + "' style='width:.65rem;height:.65rem;flex:0 0 auto;'></span>" +
        "<span class='ua-collection-order-preview-label' style='text-transform:none;letter-spacing:0;'>" + escapeHtml(segment.label || "") + "</span>" +
        "</div>" +
        "<div class='text-end'>" +
        "<div class='ua-collection-order-preview-label'>" + escapeHtml(Number(segmentPercent.toFixed(1)).toString()) + "%</div>" +
        "<div class='ua-collection-order-preview-label' style='text-transform:none;letter-spacing:0;'>" + escapeHtml(segment.value || "") + "</div>" +
        "</div>" +
        "</div>";
    }

    if (!barHtml) {
      barHtml = "<div class='progress-bar bg-light text-dark' role='progressbar' style='width:100%;' aria-valuenow='100' aria-valuemin='0' aria-valuemax='100'>No data</div>";
    }

    return "<div class='ua-collection-order-preview' data-preview-kind='segments'>" +
      (badgeHtml ? ("<div class='d-flex justify-content-end mb-2'>" + badgeHtml + "</div>") : "") +
      "<div class='d-flex justify-content-between align-items-end gap-3'>" +
      "<div class='min-w-0'>" +
      "<div class='ua-collection-order-preview-label'>" + escapeHtml(preview.label || "Breakdown") + "</div>" +
      "<div class='ua-collection-order-preview-value'>" + escapeHtml(preview.totalValue || "0") + "</div>" +
      "</div>" +
      "</div>" +
      "<div class='progress' style='height:.65rem;' aria-label='" + escapeHtml(preview.label || "Breakdown") + "'>" +
      barHtml +
      "</div>" +
      "<div class='d-flex flex-column gap-2'>" +
      rowsHtml +
      "</div>" +
      trailing +
      "</div>";
  }
  return trailing;
}

function rootEditLabel(state) {
  return (state.root.getAttribute("data-collection-edit-label") || "Edit").toString();
}

function normalizePinVisibility(value) {
  return ((value || "always").toString().trim().toLowerCase() === "edit") ? "edit" : "always";
}

function editToggleLabel(state) {
  return state.root.querySelector("[data-collection-edit-toggle='true']");
}

function escapeHtml(value) {
  return (value || "").toString()
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/\"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

function setEditMode(state, enabled) {
  if (!state.editable) return;
  state.editMode = enabled === true;
  state.root.classList.toggle("is-editing", state.editMode === true);
  syncArrangeFocusState(state);
  clearDragState(state);
  renderCollection(state);
  if (state.editMode) {
    setStatus(state, {
      text: "Arrange mode: drag cards or use arrow keys. Press Escape to finish.",
      closeEdit: true,
      closeLabel: "Exit arrange mode"
    }, false, false);
    if (!state.focusKey) {
      var firstUnlocked = state.directItems.find(function(item) { return item.locked !== true; });
      state.focusKey = firstUnlocked ? firstUnlocked.key : "";
    }
    focusCardByKey(state, state.focusKey);
  } else {
    clearStatus(state, false);
  }
  announceCollectionState(state);
}

function syncArrangeFocusState(state) {
  if (!(state && state.root) || !(document && document.body)) return;

  var roots = document.querySelectorAll("[data-ua-collection-order='true']");
  var activeRoot = null;
  for (var i = 0; i < roots.length; i++) {
    var candidate = roots[i];
    var candidateState = candidate && candidate.__uaCollectionOrderState;
    if (candidateState && candidateState.editMode === true) {
      activeRoot = candidate;
      break;
    }
  }

  for (var j = 0; j < roots.length; j++) {
    setArrangeFocusNode(roots[j], roots[j] === activeRoot);
  }

  var overlay = getArrangeFocusOverlay();
  if (overlay) overlay.style.display = activeRoot ? "block" : "none";
}

function getArrangeFocusOverlay() {
  if (!(document && document.body)) return null;
  var overlay = document.getElementById("ua-collection-arrange-overlay");
  if (overlay) return overlay;
  overlay = document.createElement("div");
  overlay.id = "ua-collection-arrange-overlay";
  overlay.setAttribute("aria-hidden", "true");
  overlay.style.position = "fixed";
  overlay.style.inset = "0";
  overlay.style.background = "rgba(12, 18, 28, .34)";
  overlay.style.backdropFilter = "blur(.08rem)";
  overlay.style.pointerEvents = "auto";
  overlay.style.zIndex = "1040";
  overlay.style.display = "none";
  document.body.appendChild(overlay);
  return overlay;
}

function setArrangeFocusNode(node, enabled) {
  if (!(node && node.style)) return;
  if (enabled) {
    if (node.getAttribute("data-ua-collection-arrange-focus") === "true") return;
    node.setAttribute("data-ua-collection-arrange-focus", "true");
    node.setAttribute("data-ua-collection-prev-position", node.style.position || "");
    node.setAttribute("data-ua-collection-prev-zindex", node.style.zIndex || "");
    node.setAttribute("data-ua-collection-prev-isolation", node.style.isolation || "");
    if ((window.getComputedStyle(node).position || "static") === "static") {
      node.style.position = "relative";
    }
    node.style.zIndex = "1041";
    node.style.isolation = "isolate";
    return;
  }

  if (node.getAttribute("data-ua-collection-arrange-focus") !== "true") return;
  node.style.position = node.getAttribute("data-ua-collection-prev-position") || "";
  node.style.zIndex = node.getAttribute("data-ua-collection-prev-zindex") || "";
  node.style.isolation = node.getAttribute("data-ua-collection-prev-isolation") || "";
  node.removeAttribute("data-ua-collection-arrange-focus");
  node.removeAttribute("data-ua-collection-prev-position");
  node.removeAttribute("data-ua-collection-prev-zindex");
  node.removeAttribute("data-ua-collection-prev-isolation");
}

function announceCollectionState(state) {
  if (!(state && state.root)) return;
  state.root.dispatchEvent(new CustomEvent("ua:collection:state-change", {
    bubbles: true,
    detail: {
      collectionName: state.name,
      editMode: state.editMode === true,
      showLocked: state.showLocked === true
    }
  }));
}

async function handleCollectionClick(state, event) {
  if (event.defaultPrevented) return;

  var removeBtn = event.target.closest("[data-collection-remove='true']");
  if (removeBtn && state.root.contains(removeBtn)) {
    event.preventDefault();
    removeCollectionItem(state, (removeBtn.getAttribute("data-collection-card-key") || "").toString());
    return;
  }

  var moveBtn = event.target.closest("[data-collection-move]");
  if (moveBtn && state.root.contains(moveBtn)) {
    event.preventDefault();
    moveCollectionItem(state, (moveBtn.getAttribute("data-collection-card-key") || "").toString(), (moveBtn.getAttribute("data-collection-move") || "").toString());
    return;
  }

  var filterChip = event.target.closest("[data-collection-filter-chip='true']");
  if (filterChip && state.root.contains(filterChip)) {
    event.preventDefault();
    var chipFilterName = (filterChip.getAttribute("data-collection-filter-name") || "").toString().trim();
    var chipFilterValue = (filterChip.getAttribute("data-collection-filter-value") || "").toString().trim();
    if (chipFilterName) {
      var currentValues = parseFilterValueList(state.filters[chipFilterName] || "");
      var nextValues = currentValues.filter(function(entry) {
        return entry !== chipFilterValue;
      });
      setCollectionFilterValue(state, chipFilterName, nextValues.join(","), COLLECTION_DEBOUNCE.filterApply);
    }
    return;
  }

  var closeEditBtn = event.target.closest("[data-collection-close-edit='true']");
  if (closeEditBtn && state.root.contains(closeEditBtn)) {
    event.preventDefault();
    setEditMode(state, false);
    return;
  }

  var actionBtn = event.target.closest("[data-collection-action='true']");
  if (actionBtn && state.root.contains(actionBtn)) {
    event.preventDefault();
    await runCollectionAction(state, actionBtn);
    return;
  }

  var routeTarget = event.target.closest("[data-collection-route]");
  if (routeTarget && state.root.contains(routeTarget) && !event.target.closest("a,button,input,label")) {
    if (!state.editMode) {
      var href = (routeTarget.getAttribute("data-collection-route") || "").toString().trim();
      if (href) window.location.href = href;
    }
  }
}

async function runCollectionAction(state, button) {
  if (!(state.dashboardApi && state.pageNamespace)) return;
  var actionName = (button.getAttribute("data-collection-action-name") || "").toString().trim();
  if (!actionName) return;
  var payload = {};
  try {
    payload = JSON.parse((button.getAttribute("data-collection-action-payload") || "{}").toString());
  } catch (error) {
    payload = {};
  }
  try {
    var response = state.apiUrl
      ? await state.dashboardApi.action(state.pageNamespace, "action", payload, state.apiUrl)
      : await state.dashboardApi.action(state.pageNamespace, "action", payload);
    if (!(response && response.success)) {
      setStatus(state, "Action failed.", true, false);
      return;
    }
    if (response.alreadyExists === true) {
      setStatus(state, "Already added to Home.", false, true);
    } else {
      setStatus(state, "Updated.", false, true);
    }
    state.root.dispatchEvent(new CustomEvent("ua:collection:action-success", {
      bubbles: true,
      detail: {
        action: actionName,
        payload: payload,
        response: response,
        pageNamespace: state.pageNamespace,
        collectionName: state.name
      }
    }));
    if (hasApiSource(state)) {
      state.cache = {};
      await loadApiSearch(state);
    }
  } catch (error) {
    console.error("Collection action failed.", error);
    setStatus(state, "Action failed.", true, false);
  }
}

function removeCollectionItem(state, key) {
  if (!key) return;
  var items = state.directItems.slice();
  var next = items.filter(function(item) {
    return item.key !== key || item.locked === true;
  });
  setCollectionItems(state, applySequentialOrder(next), {
    markPrefetched: true
  });
  resetRevealState(state);
  renderCollection(state);
  scheduleSave(state, true);
}

function moveCollectionItem(state, key, direction) {
  if (!key) return;
  var unlocked = state.directItems.filter(function(item) { return item.locked !== true; });
  var locked = state.directItems.filter(function(item) { return item.locked === true; });
  var index = unlocked.findIndex(function(item) { return item.key === key; });
  if (index < 0) return;
  var nextIndex = index;
  if (direction === "start") nextIndex = 0;
  if (direction === "up") nextIndex = Math.max(0, index - 1);
  if (direction === "down") nextIndex = Math.min(unlocked.length - 1, index + 1);
  if (direction === "end") nextIndex = unlocked.length - 1;
  if (nextIndex === index) return;
  var moved = unlocked.splice(index, 1)[0];
  unlocked.splice(nextIndex, 0, moved);
  setCollectionItems(state, applySequentialOrder(locked.concat(unlocked)), {
    markPrefetched: true
  });
  resetRevealState(state);
  renderCollection(state);
  scheduleSave(state, true);
}

function handlePointerDown(state, event) {
  if (!(state.editMode)) return;
  if (typeof event.button === "number" && event.button !== 0) return;
  if (event.target.closest("button,a,input,label,textarea,select")) return;
  var card = event.target.closest("[data-collection-card='true']");
  if (!(card) || !(state.root.contains(card))) return;
  var key = (card.getAttribute("data-card-key") || "").toString().trim();
  if (!key) return;
  var item = state.directItems.find(function(row) { return row.key === key; });
  if (!item || item.locked === true) return;

  event.preventDefault();
  clearDragState(state);
  state.focusKey = key;
  syncFocusedCardState(state);
  if (typeof card.focus === "function") card.focus();
  state.drag = {
    key: key,
    card: card,
    dropKey: key,
    dropIndex: -1,
    dropPosition: "before",
    startX: event.clientX,
    startY: event.clientY,
    offsetX: 0,
    offsetY: 0,
    activated: false,
    pointerOffsetX: 0,
    pointerOffsetY: 0,
    placeholderHeight: 0,
    size: item.size || "regular",
    ghost: null,
    pointerId: Number.isFinite(event.pointerId) ? event.pointerId : null,
    lastClientX: event.clientX,
    lastClientY: event.clientY,
    cleanupFns: []
  };

  var drag = state.drag;

  function onMove(moveEvent) {
    if (state.drag !== drag) return;
    drag.lastClientX = moveEvent.clientX;
    drag.lastClientY = moveEvent.clientY;
    drag.offsetX = moveEvent.clientX - drag.startX;
    drag.offsetY = moveEvent.clientY - drag.startY;
    if (!(drag.activated)) {
      if (Math.abs(drag.offsetX) < 6 && Math.abs(drag.offsetY) < 6) return;
      activateDragState(state, moveEvent, item);
    }
    positionDragGhost(drag, moveEvent.clientX, moveEvent.clientY);
    if (updateDropTarget(state, moveEvent.clientX, moveEvent.clientY)) {
      renderCollection(state);
    }
  }

  function finishDrag(shouldCommit) {
    if (state.drag !== drag) return;
    var finishedDrag = state.drag;
    clearDragState(state);
    if (!(finishedDrag && finishedDrag.activated && finishedDrag.key && shouldCommit === true)) {
      renderCollection(state);
      focusCardByKey(state, key);
      return;
    }

    if (Number.isFinite(finishedDrag.dropIndex) && finishedDrag.dropIndex >= 0) {
      reorderByIndex(state, finishedDrag.key, finishedDrag.dropIndex);
    } else if (finishedDrag.dropKey && finishedDrag.key !== finishedDrag.dropKey) {
      reorderByDrop(state, finishedDrag.key, finishedDrag.dropKey, finishedDrag.dropPosition || "before");
    } else {
      renderCollection(state);
    }
    focusCardByKey(state, finishedDrag.key);
  }

  function onUp(upEvent) {
    if (state.drag !== drag) return;
    if (drag.pointerId != null && upEvent && Number.isFinite(upEvent.pointerId) && upEvent.pointerId !== drag.pointerId) return;
    finishDrag(true);
  }

  function onCancel(cancelEvent) {
    if (state.drag !== drag) return;
    if (cancelEvent && cancelEvent.type === "lostpointercapture" && drag.pointerId != null && Number.isFinite(cancelEvent.pointerId) && cancelEvent.pointerId !== drag.pointerId) return;
    finishDrag(false);
  }

  function onVisibilityChange() {
    if (document.visibilityState === "hidden") onCancel();
  }

  document.addEventListener("pointermove", onMove, true);
  document.addEventListener("pointerup", onUp, true);
  document.addEventListener("pointercancel", onCancel, true);
  window.addEventListener("blur", onCancel);
  document.addEventListener("visibilitychange", onVisibilityChange);
  state.root.addEventListener("lostpointercapture", onCancel, true);

  drag.cleanupFns.push(function() {
    document.removeEventListener("pointermove", onMove, true);
    document.removeEventListener("pointerup", onUp, true);
    document.removeEventListener("pointercancel", onCancel, true);
    window.removeEventListener("blur", onCancel);
    document.removeEventListener("visibilitychange", onVisibilityChange);
    state.root.removeEventListener("lostpointercapture", onCancel, true);
  });

  if (drag.pointerId != null && state.root && typeof state.root.setPointerCapture === "function") {
    try {
      state.root.setPointerCapture(drag.pointerId);
    } catch (error) {
      console.warn("Collection drag pointer capture failed.", { error: error });
    }
  }
}

function updateDropTarget(state, clientX, clientY) {
  if (!(state && state.drag && state.drag.activated)) return false;
  var target = findDropTarget(state, clientX, clientY);
  if (!(target)) return false;

  var nextKey = (target.key || "").toString();
  var nextPosition = (target.position || "before").toString();
  var nextIndex = Math.max(0, Number(target.index) || 0);

  if (state.drag.dropKey === nextKey &&
      state.drag.dropPosition === nextPosition &&
      state.drag.dropIndex === nextIndex) {
    return false;
  }

  state.drag.dropKey = nextKey;
  state.drag.dropPosition = nextPosition;
  state.drag.dropIndex = nextIndex;
  return true;
}

function clearDragState(state) {
  if (state.drag && state.drag.cleanupFns instanceof Array) {
    while (state.drag.cleanupFns.length > 0) {
      var cleanup = state.drag.cleanupFns.pop();
      try {
        cleanup();
      } catch (error) {
        console.warn("Collection drag cleanup failed.", { error: error });
      }
    }
  }
  if (state.drag && state.drag.pointerId != null && state.root && typeof state.root.releasePointerCapture === "function") {
    try {
      if (!(state.root.hasPointerCapture) || state.root.hasPointerCapture(state.drag.pointerId)) {
        state.root.releasePointerCapture(state.drag.pointerId);
      }
    } catch (error) {
      console.warn("Collection drag pointer release failed.", { error: error });
    }
  }
  if (state.drag && state.drag.card) {
    state.drag.card.classList.remove("is-dragging");
    state.drag.card.style.transform = "";
    state.drag.card.style.pointerEvents = "";
  }
  if (state.drag && state.drag.ghost && state.drag.ghost.parentNode) {
    state.drag.ghost.parentNode.removeChild(state.drag.ghost);
  }
  state.drag = null;
}

function activateDragState(state, event, item) {
  if (!(state && state.drag && state.drag.card)) return;
  var wrap = state.drag.card.closest("[data-card-key]") || state.drag.card;
  var rect = normalizeRect(wrap.getBoundingClientRect());
  state.drag.activated = true;
  state.drag.placeholderHeight = Math.max(120, Math.round(rect.height || 0));
  state.drag.size = item && item.size ? item.size : state.drag.size;
  state.drag.pointerOffsetX = event.clientX - rect.left;
  state.drag.pointerOffsetY = event.clientY - rect.top;
  state.drag.ghost = createDragGhost(state, wrap, rect);
  positionDragGhost(state.drag, event.clientX, event.clientY);
  renderCollection(state);
  refreshDragLayout(state);
}

function createDragGhost(state, wrap, rect) {
  if (!(wrap && document && document.body)) return null;
  var ghost = wrap.cloneNode(true);
  ghost.classList.add("ua-collection-order-drag-ghost");
  ghost.setAttribute("aria-hidden", "true");
  ghost.style.position = "fixed";
  ghost.style.left = rect.left + "px";
  ghost.style.top = rect.top + "px";
  ghost.style.width = rect.width + "px";
  ghost.style.height = rect.height + "px";
  ghost.style.margin = "0";
  ghost.style.pointerEvents = "none";
  ghost.style.zIndex = "1055";

  var ghostCard = ghost.querySelector("[data-collection-card='true']");
  if (ghostCard) {
    ghostCard.classList.add("is-dragging");
    ghostCard.removeAttribute("tabindex");
  }

  var host = state.root.closest("uae[namespace='ua.collection.order']") || state.root || document.body;
  host.appendChild(ghost);
  return ghost;
}

function positionDragGhost(drag, clientX, clientY) {
  if (!(drag && drag.ghost)) return;
  drag.ghost.style.left = (clientX - (drag.pointerOffsetX || 0)) + "px";
  drag.ghost.style.top = (clientY - (drag.pointerOffsetY || 0)) + "px";
}

function normalizeRect(rect) {
  if (!(rect)) {
    return {
      left: 0,
      top: 0,
      right: 0,
      bottom: 0,
      width: 0,
      height: 0
    };
  }

  var left = Number(rect.left) || 0;
  var top = Number(rect.top) || 0;
  var width = Math.max(0, Number(rect.width) || ((Number(rect.right) || 0) - left));
  var height = Math.max(0, Number(rect.height) || ((Number(rect.bottom) || 0) - top));

  return {
    left: left,
    top: top,
    right: left + width,
    bottom: top + height,
    width: width,
    height: height
  };
}

function isSameVisualRow(leftRect, rightRect) {
  if (!(leftRect && rightRect)) return false;
  var rowAllowance = Math.max(1, Math.min(leftRect.height || 0, rightRect.height || 0) * 0.35, 18);
  return Math.abs((leftRect.top || 0) - (rightRect.top || 0)) <= rowAllowance;
}

function pointInRect(rect, clientX, clientY) {
  if (!(rect)) return false;
  return clientX >= rect.left && clientX <= rect.right && clientY >= rect.top && clientY <= rect.bottom;
}

function expandRect(rect, horizontalPadding, verticalPadding) {
  var base = normalizeRect(rect);
  var padX = Math.max(0, Number(horizontalPadding) || 0);
  var padY = Math.max(0, Number(verticalPadding) || 0);

  return normalizeRect({
    left: base.left - padX,
    top: base.top - padY,
    width: base.width + (padX * 2),
    height: base.height + (padY * 2)
  });
}

function centerY(rect) {
  return (rect.top || 0) + ((rect.height || 0) / 2);
}

function centerX(rect) {
  return (rect.left || 0) + ((rect.width || 0) / 2);
}

function clampNumber(value, min, max) {
  var nextValue = Number(value) || 0;
  var minValue = Number(min);
  var maxValue = Number(max);
  if (Number.isFinite(minValue) && nextValue < minValue) return minValue;
  if (Number.isFinite(maxValue) && nextValue > maxValue) return maxValue;
  return nextValue;
}

function distanceToRect(rect, clientX, clientY) {
  var bounds = normalizeRect(rect);
  var dx = 0;
  if (clientX < bounds.left) dx = bounds.left - clientX;
  else if (clientX > bounds.right) dx = clientX - bounds.right;

  var dy = 0;
  if (clientY < bounds.top) dy = bounds.top - clientY;
  else if (clientY > bounds.bottom) dy = clientY - bounds.bottom;

  return Math.sqrt((dx * dx) + (dy * dy));
}

function buildLayoutRows(entries) {
  var rows = [];
  if (!(entries instanceof Array)) return rows;

  for (var i = 0; i < entries.length; i++) {
    var entry = entries[i];
    if (!(entry && entry.rect)) continue;
    var currentRow = rows.length > 0 ? rows[rows.length - 1] : null;

    if (!(currentRow) || !isSameVisualRow(currentRow.anchorRect, entry.rect)) {
      currentRow = {
        firstIndex: i,
        lastIndex: i,
        left: entry.rect.left,
        right: entry.rect.right,
        top: entry.rect.top,
        bottom: entry.rect.bottom,
        height: entry.rect.height || 0,
        anchorRect: entry.rect
      };
      rows.push(currentRow);
    } else {
      currentRow.lastIndex = i;
      currentRow.left = Math.min(currentRow.left, entry.rect.left);
      currentRow.right = Math.max(currentRow.right, entry.rect.right);
      currentRow.top = Math.min(currentRow.top, entry.rect.top);
      currentRow.bottom = Math.max(currentRow.bottom, entry.rect.bottom);
      currentRow.height = Math.max(currentRow.height, entry.rect.height || 0);
    }
  }

  return rows;
}

function findNearestLayoutRow(layout, clientY) {
  if (!(layout && layout.rows instanceof Array) || layout.rows.length === 0) return null;

  var bestRow = null;
  var bestDistance = Number.POSITIVE_INFINITY;

  for (var i = 0; i < layout.rows.length; i++) {
    var row = layout.rows[i];
    var verticalSlack = Math.max(24, Math.min(72, (row.height || 0) * 0.45));
    var paddedTop = row.top - verticalSlack;
    var paddedBottom = row.bottom + verticalSlack;
    var distance = 0;

    if (clientY < paddedTop) distance = paddedTop - clientY;
    else if (clientY > paddedBottom) distance = clientY - paddedBottom;

    if (distance < bestDistance) {
      bestDistance = distance;
      bestRow = row;
    }
  }

  return bestRow;
}

function resolveRowEdgeSlot(layout, clientX, clientY) {
  if (!(layout && layout.rows instanceof Array) || layout.rows.length === 0) return null;

  var row = findNearestLayoutRow(layout, clientY);
  if (!(row)) return null;

  var verticalSlack = Math.max(24, Math.min(72, (row.height || 0) * 0.45));
  if (clientY < (row.top - verticalSlack) || clientY > (row.bottom + verticalSlack)) return null;

  var gridRect = normalizeRect(layout.gridRect);
  var leadingSpace = Math.max(0, row.left - gridRect.left);
  var trailingSpace = Math.max(0, gridRect.right - row.right);
  var leadingTrigger = row.left - (leadingSpace > 16 ? Math.min(18, leadingSpace * 0.3) : 18);
  var trailingTrigger = row.right + (trailingSpace > 16 ? Math.min(18, trailingSpace * 0.3) : 18);

  if (clientX <= leadingTrigger) {
    return findSlotByIndex(layout, row.firstIndex);
  }

  if (clientX >= trailingTrigger) {
    return findSlotByIndex(layout, row.lastIndex + 1) || layout.slots[layout.slots.length - 1];
  }

  return null;
}

function projectPointToLayout(layout, clientX, clientY) {
  var gridRect = normalizeRect((layout || {}).gridRect);
  var sampleRect = (((layout || {}).entries || [])[0] || {}).rect || gridRect;
  var horizontalPadding = Math.max(72, Math.min(180, (sampleRect.width || gridRect.width || 120) * 0.9));
  var verticalPadding = Math.max(48, Math.min(140, (sampleRect.height || gridRect.height || 120) * 0.75));
  var projectionRect = expandRect(gridRect, horizontalPadding, verticalPadding);

  return {
    x: clampNumber(clientX, projectionRect.left, projectionRect.right),
    y: clampNumber(clientY, projectionRect.top, projectionRect.bottom)
  };
}

function buildDropSlot(entries, gridRect, index) {
  var prev = index > 0 ? entries[index - 1] : null;
  var next = index < entries.length ? entries[index] : null;
  var slot = {
    index: index,
    key: next ? next.key : (prev ? prev.key : ""),
    position: next ? "before" : "after",
    x: gridRect.left || 0,
    y: gridRect.top || 0,
    bounds: normalizeRect({
      left: gridRect.left || 0,
      top: gridRect.top || 0,
      width: Math.max(1, gridRect.width || 1),
      height: Math.max(1, gridRect.height || 1)
    })
  };

  if (!(prev) && next) {
    var leadingWidth = Math.max(48, Math.min(next.rect.width || 0, Math.max((next.rect.width || 0) * 0.58, 88)));
    slot.x = gridRect.left + (leadingWidth / 2);
    slot.y = centerY(next.rect);
    slot.bounds = normalizeRect({
      left: gridRect.left,
      top: Math.min(gridRect.top, next.rect.top - 24),
      width: Math.max(1, (next.rect.left - gridRect.left) + leadingWidth),
      height: Math.max(48, (next.rect.bottom - Math.min(gridRect.top, next.rect.top - 24)))
    });
    return slot;
  }

  if (prev && !(next)) {
    var trailingGap = Math.max(0, (gridRect.right || prev.rect.right) - prev.rect.right);
    var trailingWidth = trailingGap > 24 ? trailingGap : Math.max(72, Math.min(prev.rect.width || 120, 180));
    var trailingTop = isSameVisualRow(prev.rect, gridRect)
      ? prev.rect.top
      : prev.rect.top;

    slot.x = trailingGap > 24 ? (prev.rect.right + (trailingGap / 2)) : (prev.rect.right + Math.min(trailingWidth / 2, 72));
    slot.y = trailingGap > 24 ? centerY(prev.rect) : (prev.rect.bottom + 24);
    slot.bounds = normalizeRect({
      left: trailingGap > 24 ? prev.rect.right : gridRect.left,
      top: trailingGap > 24 ? prev.rect.top : (prev.rect.bottom - 24),
      width: trailingGap > 24 ? trailingWidth : Math.max(gridRect.width || prev.rect.width || 1, 1),
      height: trailingGap > 24 ? Math.max(prev.rect.height || 48, 48) : 96
    });
    return slot;
  }

  if (!(prev && next)) {
    return slot;
  }

  if (isSameVisualRow(prev.rect, next.rect)) {
    var gap = next.rect.left - prev.rect.right;
    var slotX = gap > 0 ? (prev.rect.right + (gap / 2)) : ((prev.rect.right + next.rect.left) / 2);
    slot.x = slotX;
    slot.y = (centerY(prev.rect) + centerY(next.rect)) / 2;
    slot.bounds = normalizeRect({
      left: gap > 0 ? prev.rect.right : (slotX - 18),
      top: Math.min(prev.rect.top, next.rect.top),
      width: gap > 0 ? Math.max(18, gap) : 36,
      height: Math.max(prev.rect.bottom, next.rect.bottom) - Math.min(prev.rect.top, next.rect.top)
    });
    return slot;
  }

  var verticalGap = next.rect.top - prev.rect.bottom;
  slot.x = next.rect.left;
  slot.y = verticalGap > 0 ? (prev.rect.bottom + (verticalGap / 2)) : next.rect.top;
  slot.bounds = normalizeRect({
    left: gridRect.left,
    top: verticalGap > 0 ? prev.rect.bottom : (next.rect.top - 24),
    width: Math.max(1, gridRect.width || 1),
    height: verticalGap > 0 ? Math.max(24, verticalGap) : 48
  });
  return slot;
}

function buildDropSlots(entries, gridRect) {
  var slots = [];
  if (!(entries instanceof Array) || entries.length === 0) {
    slots.push({
      index: 0,
      key: "",
      position: "before",
      x: (gridRect.left || 0) + Math.min(96, Math.max(32, (gridRect.width || 0) / 2)),
      y: (gridRect.top || 0) + 32,
      bounds: normalizeRect({
        left: gridRect.left || 0,
        top: gridRect.top || 0,
        width: Math.max(1, gridRect.width || 1),
        height: Math.max(64, gridRect.height || 64)
      })
    });
    return slots;
  }

  for (var index = 0; index <= entries.length; index++) {
    slots.push(buildDropSlot(entries, gridRect, index));
  }

  return slots;
}

function measureDragLayout(state) {
  if (!(state && state.root)) return null;
  var grid = state.grid || state.root.querySelector("[data-collection-grid='true']");
  var gridRect = normalizeRect(grid ? grid.getBoundingClientRect() : null);
  var movingKey = ((state.drag || {}).key || "").toString();
  var wraps = state.root.querySelectorAll(".ua-collection-order-card-wrap[data-card-key][data-card-locked='false']");
  var entries = [];

  wraps.forEach(function(wrap) {
    var key = (wrap.getAttribute("data-card-key") || "").toString();
    if (!key || key === movingKey) return;
    var card = wrap.querySelector("[data-collection-card='true']");
    entries.push({
      key: key,
      wrap: wrap,
      card: card,
      rect: normalizeRect(wrap.getBoundingClientRect())
    });
  });

  return {
    gridRect: gridRect,
    entries: entries,
    rows: buildLayoutRows(entries),
    slots: buildDropSlots(entries, gridRect)
  };
}

function refreshDragLayout(state) {
  if (!(state && state.drag && state.drag.activated)) return;
  state.drag.layout = measureDragLayout(state);
}

function getDragLayout(state) {
  if (!(state && state.drag && state.drag.activated)) return null;
  if (!(state.drag.layout)) {
    state.drag.layout = measureDragLayout(state);
  }
  return state.drag.layout;
}

function distanceToSlot(slot, clientX, clientY) {
  if (slot && slot.bounds) {
    var boundsDistance = distanceToRect(slot.bounds, clientX, clientY);
    if (boundsDistance > 0) return boundsDistance;
  }
  var dx = clientX - (slot.x || 0);
  var dy = clientY - (slot.y || 0);
  return Math.sqrt((dx * dx) + (dy * dy)) * 0.12;
}

function findSlotByIndex(layout, index) {
  if (!(layout && layout.slots instanceof Array)) return null;
  for (var i = 0; i < layout.slots.length; i++) {
    if ((layout.slots[i].index || 0) === index) return layout.slots[i];
  }
  return null;
}

function resolveSlotFromPoint(layout, clientX, clientY) {
  if (!(layout && layout.slots instanceof Array) || layout.slots.length === 0) return null;

  var entries = layout.entries instanceof Array ? layout.entries : [];
  if (entries.length > 0) {
    var firstRect = entries[0].rect;
    var lastRect = entries[entries.length - 1].rect;
    if (clientY <= (firstRect.top - 12)) {
      return layout.slots[0];
    }
    if (clientY >= (lastRect.bottom + 12)) {
      return layout.slots[layout.slots.length - 1];
    }
  }

  var containing = [];
  for (var i = 0; i < layout.slots.length; i++) {
    if (pointInRect(layout.slots[i].bounds, clientX, clientY)) {
      containing.push(layout.slots[i]);
    }
  }

  var pool = containing.length > 0 ? containing : layout.slots;
  var bestSlot = null;
  var bestDistance = Number.POSITIVE_INFINITY;

  for (var slotIndex = 0; slotIndex < pool.length; slotIndex++) {
    var distance = distanceToSlot(pool[slotIndex], clientX, clientY);
    if (distance < bestDistance) {
      bestDistance = distance;
      bestSlot = pool[slotIndex];
    }
  }

  return bestSlot;
}

function findDropTarget(state, clientX, clientY) {
  var layout = getDragLayout(state);
  if (!(layout) || layout.entries.length === 0) {
    return {
      key: (state.drag || {}).key || "",
      position: "before",
      index: 0
    };
  }

  var currentIndex = Math.max(0, Number(((state.drag || {}).dropIndex)) || 0);
  var currentSlot = findSlotByIndex(layout, currentIndex);
  if (currentSlot) {
    var stickyBounds = expandRect(
      currentSlot.bounds,
      Math.max(18, Math.min(48, (currentSlot.bounds.width || 0) * 0.2)),
      Math.max(18, Math.min(42, (currentSlot.bounds.height || 0) * 0.24))
    );
    if (pointInRect(stickyBounds, clientX, clientY)) {
      return {
        key: (currentSlot.key || "").toString(),
        position: (currentSlot.position || "before").toString(),
        index: Math.max(0, Number(currentSlot.index) || 0)
      };
    }
  }

  var rowEdgeSlot = resolveRowEdgeSlot(layout, clientX, clientY);
  if (rowEdgeSlot) {
    return {
      key: (rowEdgeSlot.key || "").toString(),
      position: (rowEdgeSlot.position || "before").toString(),
      index: Math.max(0, Number(rowEdgeSlot.index) || 0)
    };
  }

  var projectedPoint = projectPointToLayout(layout, clientX, clientY);
  var slot = resolveSlotFromPoint(layout, projectedPoint.x, projectedPoint.y);
  if (!(slot)) return null;
  return {
    key: (slot.key || "").toString(),
    position: (slot.position || "before").toString(),
    index: Math.max(0, Number(slot.index) || 0)
  };
}

function reorderByIndex(state, movingKey, dropIndex) {
  var unlocked = state.directItems.filter(function(item) { return item.locked !== true; });
  var locked = state.directItems.filter(function(item) { return item.locked === true; });
  var fromIndex = unlocked.findIndex(function(item) { return item.key === movingKey; });
  if (fromIndex < 0) return;

  var moved = unlocked.splice(fromIndex, 1)[0];
  var insertIndex = Math.max(0, Math.min(unlocked.length, Number(dropIndex) || 0));
  if (insertIndex === fromIndex) return;

  unlocked.splice(insertIndex, 0, moved);
  setCollectionItems(state, applySequentialOrder(locked.concat(unlocked)), {
    markPrefetched: true
  });
  resetRevealState(state);
  renderCollection(state);
  scheduleSave(state, true);
}

function reorderByDrop(state, movingKey, targetKey, dropPosition) {
  var unlocked = state.directItems.filter(function(item) { return item.locked !== true; });
  var locked = state.directItems.filter(function(item) { return item.locked === true; });
  var fromIndex = unlocked.findIndex(function(item) { return item.key === movingKey; });
  var toIndex = unlocked.findIndex(function(item) { return item.key === targetKey; });
  if (fromIndex < 0 || toIndex < 0 || fromIndex === toIndex) return;
  var moved = unlocked.splice(fromIndex, 1)[0];
  var insertIndex = toIndex;
  if ((dropPosition || "before") === "after") {
    insertIndex = fromIndex < toIndex ? toIndex : (toIndex + 1);
  } else if (fromIndex < toIndex) {
    insertIndex = Math.max(0, toIndex - 1);
  }
  unlocked.splice(insertIndex, 0, moved);
  setCollectionItems(state, applySequentialOrder(locked.concat(unlocked)), {
    markPrefetched: true
  });
  resetRevealState(state);
  renderCollection(state);
  scheduleSave(state, true);
}

function syncFocusedCardState(state) {
  if (!(state && state.root)) return;
  state.root.querySelectorAll("[data-card-focused]").forEach(function(node) {
    var key = (node.getAttribute("data-card-key") || "").toString();
    node.setAttribute("data-card-focused", key && key === state.focusKey ? "true" : "false");
  });
}

function focusCardByKey(state, key) {
  if (!(state && state.root && key)) return;
  state.focusKey = key;
  syncFocusedCardState(state);
  var card = state.root.querySelector("[data-collection-card='true'][data-card-key='" + cssEscapeAttr(key) + "']");
  if (card && typeof card.focus === "function") {
    requestAnimationFrame(function() {
      try {
        card.focus({ preventScroll: false });
      } catch (error) {
        card.focus();
      }
    });
  }
}

function handleCollectionKeydown(state, event) {
  if (!(state && state.editMode)) return;
  if (event.target && event.target.closest && event.target.closest("button,a,input,label,textarea,select") && !(event.target.matches && event.target.matches("[data-collection-card='true']"))) {
    return;
  }
  var card = event.target.closest("[data-collection-card='true']");
  if (!(card) || !(state.root.contains(card))) return;
  var key = (card.getAttribute("data-card-key") || "").toString().trim();
  if (!key) return;

  var eventKey = (event.key || "").toString();
  var useEdgeMove = event.metaKey === true || event.ctrlKey === true;
  var direction = "";

  if (eventKey === "Escape") {
    event.preventDefault();
    setEditMode(state, false);
    return;
  }

  if (eventKey === "ArrowUp" || eventKey === "ArrowLeft") {
    direction = useEdgeMove ? "start" : "up";
  } else if (eventKey === "ArrowDown" || eventKey === "ArrowRight") {
    direction = useEdgeMove ? "end" : "down";
  } else if (eventKey === "Home") {
    direction = "start";
  } else if (eventKey === "End") {
    direction = "end";
  } else {
    return;
  }

  event.preventDefault();
  moveCollectionItem(state, key, direction);
  focusCardByKey(state, key);
}

function cssEscapeAttr(value) {
  var text = (value || "").toString();
  if (window.CSS && typeof window.CSS.escape === "function") return window.CSS.escape(text);
  return text.replace(/["\\]/g, "\\$&");
}

async function maybeAdvanceCollection(state) {
  var result = getResultState(state);
  var total = getFilteredTotal(state);
  if (result.visibleCount < total) {
    bumpVisibleCount(state, result);
    renderCollection(state);
    return;
  }
  if (!hasApiSource(state) || result.exhausted || result.loading) return;
  await loadNextApiPage(state, result, false);
  bumpVisibleCount(state, result);
  renderCollection(state);
}

function scheduleSave(state, announce) {
  if (state.saveMode !== "dashboard-save") return;
  if (!(state.dashboardApi && state.pageNamespace)) return;
  if (state.pendingSaveTimer) clearTimeout(state.pendingSaveTimer);
  state.pendingSaveTimer = setTimeout(function() {
    state.pendingSaveTimer = null;
    saveCollectionState(state);
  }, state.saveDebounceMs);
}

async function saveCollectionState(state) {
  var payload = {
    showDefaults: state.showLocked,
    items: state.directItems.filter(function(item) { return item.locked !== true; }).map(function(item, index) {
      var saveData = item.saveData && typeof item.saveData === "object" ? { ...item.saveData } : {};
      saveData.key = item.key;
      saveData.order = index + 1;
      return saveData;
    })
  };

  try {
    var response = state.apiUrl
      ? await state.dashboardApi.save(state.pageNamespace, state.saveId || "", payload, state.apiUrl)
      : await state.dashboardApi.save(state.pageNamespace, state.saveId || "", payload);
    if (!(response && response.success)) {
      setStatus(state, "Save failed.", true, false);
      return;
    }
  } catch (error) {
    console.error("Collection save failed.", error);
    setStatus(state, "Save failed.", true, false);
  }
}

module.exports.tests = [{
  namespace: "ua.collection.order.client.dropSlot.sameRowGap",
  must: 1,
  run: async function() {
    var layout = {
      gridRect: normalizeRect({ left: 0, top: 0, width: 360, height: 180 }),
      entries: [
        { key: "a", rect: normalizeRect({ left: 0, top: 0, width: 120, height: 120 }) },
        { key: "b", rect: normalizeRect({ left: 180, top: 0, width: 120, height: 120 }) }
      ]
    };
    layout.slots = buildDropSlots(layout.entries, layout.gridRect);
    return (resolveSlotFromPoint(layout, 150, 60) || {}).index;
  }
}, {
  namespace: "ua.collection.order.client.dropSlot.rowGap",
  must: 1,
  run: async function() {
    var layout = {
      gridRect: normalizeRect({ left: 0, top: 0, width: 360, height: 360 }),
      entries: [
        { key: "a", rect: normalizeRect({ left: 0, top: 0, width: 140, height: 120 }) },
        { key: "b", rect: normalizeRect({ left: 0, top: 220, width: 140, height: 120 }) }
      ]
    };
    layout.slots = buildDropSlots(layout.entries, layout.gridRect);
    return (resolveSlotFromPoint(layout, 120, 170) || {}).index;
  }
}, {
  namespace: "ua.collection.order.client.dropSlot.trailingArea",
  must: 3,
  run: async function() {
    var layout = {
      gridRect: normalizeRect({ left: 0, top: 0, width: 480, height: 200 }),
      entries: [
        { key: "a", rect: normalizeRect({ left: 0, top: 0, width: 120, height: 120 }) },
        { key: "b", rect: normalizeRect({ left: 140, top: 0, width: 120, height: 120 }) },
        { key: "c", rect: normalizeRect({ left: 280, top: 0, width: 120, height: 120 }) }
      ]
    };
    layout.slots = buildDropSlots(layout.entries, layout.gridRect);
    return (resolveSlotFromPoint(layout, 440, 60) || {}).index;
  }
}, {
  namespace: "ua.collection.order.client.dropSlot.rowTrailingOffGrid",
  must: 2,
  run: async function() {
    var layout = {
      gridRect: normalizeRect({ left: 0, top: 0, width: 420, height: 320 }),
      entries: [
        { key: "a", rect: normalizeRect({ left: 0, top: 0, width: 120, height: 120 }) },
        { key: "b", rect: normalizeRect({ left: 140, top: 0, width: 120, height: 120 }) },
        { key: "c", rect: normalizeRect({ left: 0, top: 160, width: 120, height: 120 }) }
      ]
    };
    layout.rows = buildLayoutRows(layout.entries);
    layout.slots = buildDropSlots(layout.entries, layout.gridRect);
    return (resolveRowEdgeSlot(layout, 332, 56) || {}).index;
  }
}, {
  namespace: "ua.collection.order.client.dropSlot.projectedFarEdge",
  must: 2,
  run: async function() {
    var layout = {
      gridRect: normalizeRect({ left: 0, top: 0, width: 420, height: 320 }),
      entries: [
        { key: "a", rect: normalizeRect({ left: 0, top: 0, width: 120, height: 120 }) },
        { key: "b", rect: normalizeRect({ left: 140, top: 0, width: 120, height: 120 }) },
        { key: "c", rect: normalizeRect({ left: 0, top: 160, width: 120, height: 120 }) }
      ]
    };
    layout.rows = buildLayoutRows(layout.entries);
    layout.slots = buildDropSlots(layout.entries, layout.gridRect);
    var projected = projectPointToLayout(layout, 640, 48);
    return (resolveSlotFromPoint(layout, projected.x, projected.y) || {}).index;
  }
}];
